import React, { Component, useReducer } from "react";
import { withRouter } from "react-router-dom";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification, textDirection } from "./Utils";
import CreatableSelect from 'react-select/creatable';
import TranslationPanel from "./TranslationPanel";


class Procedure extends Component {
  constructor() {
    super();
    this.state = {
      dataStartedProcessing: false,
      translationFor: null,
      healthSystemGroupValue: [],
      hospitalGroupValue: [],
      serviceLineGroupValue: [],
      agents: [],
      avatars: [],
      selectedAgent: "",
      clonedId: "",
      editableModeOn: false,
      dontOverLap: false,
      selectedHealthSystemId: "",
      selectedHospitalId: "",
      selectedServiceLineId: "",
      showLoader: false,
      noTreatments: false,
      showPassPhrase: false,
      showAgent: false,
      passPhrase: "",
      healthSystemId: "",
      hospitalId: "",
      serviceLineId: "",
      treatmentId: "",
      treatmentName: "",
      data: [
        {
          id: "",
          name: "",
          description: "",
        },
      ],
      allData: [
        {
          id: "",
          name: "",
          description: "",
        },
      ],
      hideTextAreaPopup: false,
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      paginationValue: 10,
      topHeading: "",
      editedDescription: "",
      editedName: "",
      fromClone: false,
      discontinued: false,
      cloning: false,
      showQrCode: false,
      qrCode: "",
      isDragging: false,
      modalPosition: { x: 0, y: 0 },
      cursorStartPosition: { x: 0, y: 0 },
      searchTerm: "",
      highlightButtons: {},
      noMatchingData: false,
      highlightRuleButton: {},
      highlightMileStoneButton: {},
      highlightStandaloneReminderButton: {},
      // Stand-alone reminders
      showStandaloneReminders: false,
      standaloneReminderTreatmentId: "",
      standaloneReminderTreatmentName: "",
      // Who created the treatment whose reminders are open: a provider may only view another's.
      standaloneReminderCreatedBy: "",
      milestoneReminders: [],
      reminderMilestones: [],
      reminderMilestonesLoaded: false,
      editedReminderId: "-1",
      disableAddReminderButton: false,
      reminderMilestoneId: "",
      reminderMilestoneName: "",
      reminderOffsetType: "SPECIFIC_TIME",
      reminderDayOffset: "0",
      reminderHourOffset: "0",
      reminderMinuteOffset: "0",
      reminderTimeOfDay: "",
      reminderTitle: "",
      reminderContent: "",
      // Reminder translation
      showReminderTranslationModal: false,
      reminderTranslationLanguages: [],
      selectedReminderLanguage: "",
      selectedReminderForTranslation: null,
      reminderTranslationFields: { title: "", content: "" },
      reminderAutoTranslating: false,
      translationApprovalStatus: {}, // { treatmentId: "green" | "amber" | "red" }
      isLoading: true,
      showTreatmentMileStones: false,
      selectedOptions: [],
      selectedMileStoneNames: [],
      predefinedMileStones: [],
      selectedTreatmentForMilestone: "",
      inputValue: "",
      selectedTreatmentCreatedBy: "",
      selectedFilter: "",
      allPhysicians: [],
      selectedPhysicianId: "",
      enableAgent: false,
      highlightAgentButton: {},
      treatmentAgentId: "",
      treatmentAgentName: "",
      treatmentAvatarName: "",
      tableReady: false,
      preSearchPage: 1,
      configuredLanguages: {},
      providerOwnTreatmentIds: null,
    };
    this.searchDebounceTimer = null;
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.healthSystemDropDownInProcedureRef = React.createRef();
    this.hospitalDropDownInProcedureRef = React.createRef();
    this.serviceLineDropDownInProcedureRef = React.createRef();
  }

  componentDidMount() {
    var thisController = this;

    const savedPage = localStorage.getItem("lastActivePageNum");
    if (savedPage !== null) {
      thisController.restoredPage = parseInt(savedPage);
      localStorage.removeItem("lastActivePageNum");
    } else {
      thisController.restoredPage = 1;
    }

    thisController.fetchPredefinedMileStones();
    if (thisController.userDetails.userRole === "PHYSICIAN") {
      thisController.fetchAllPhysicians();
      thisController.fetchProviderOwnTreatmentIds();
      var lastUsedDropdown = localStorage.getItem("last-used-dropdown");
      if (lastUsedDropdown === "mine") {
        thisController.state.selectedHealthSystemId =
          localStorage.getItem("healthSystemId");
        thisController.state.selectedHospitalId =
          localStorage.getItem("hospitalId");
        thisController.state.selectedServiceLineId =
          localStorage.getItem("serviceLineId");
        var userRole = thisController.userDetails["userRole"];
        if (userRole == "ADMIN") {
          thisController.state.selectedHealthSystemId =
            localStorage.getItem("healthSystemId");
          thisController.state.selectedHospitalId =
            localStorage.getItem("hospitalId");
          thisController.state.selectedServiceLineId =
            localStorage.getItem("serviceLineId");
        } else if (userRole == "HEALTHSYSTEM_ADMIN") {
          thisController.state.selectedServiceLineId =
            localStorage.getItem("serviceLineId");
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId =
            localStorage.getItem("hospitalId");
        } else {
          thisController.state.selectedServiceLineId =
            localStorage.getItem("serviceLineId");
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId =
            thisController.userDetails["hospitalId"];
        }

        if (window.SCOPE_VALUE.CURRENT <= window.SCOPE_VALUE.SERVICELINE_ADMIN) {
          thisController.state.selectedServiceLineId =
            thisController.userDetails["serviceLineId"];
        }
        thisController.setState(thisController.state);
        thisController.fetchHealthSystemDetails();
      } else if (lastUsedDropdown === "myHospital") {
        thisController.fetchTreatmentsOfHospital();
      } else if (lastUsedDropdown === "myDepartment") {
        thisController.fetchTreatmentsOfDepartment();
      } else if (lastUsedDropdown === null) {
        thisController.state.selectedHealthSystemId =
          localStorage.getItem("healthSystemId");
        thisController.state.selectedHospitalId =
          localStorage.getItem("hospitalId");
        thisController.state.selectedServiceLineId =
          localStorage.getItem("serviceLineId");
        var userRole = thisController.userDetails["userRole"];
        if (userRole == "ADMIN") {
          thisController.state.selectedHealthSystemId =
            localStorage.getItem("healthSystemId");
          thisController.state.selectedHospitalId =
            localStorage.getItem("hospitalId");
          thisController.state.selectedServiceLineId =
            localStorage.getItem("serviceLineId");
        } else if (userRole == "HEALTHSYSTEM_ADMIN") {
          thisController.state.selectedServiceLineId =
            localStorage.getItem("serviceLineId");
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId =
            localStorage.getItem("hospitalId");
        } else {
          thisController.state.selectedServiceLineId =
            localStorage.getItem("serviceLineId");
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId =
            thisController.userDetails["hospitalId"];
        }

        if (window.SCOPE_VALUE.CURRENT <= window.SCOPE_VALUE.SERVICELINE_ADMIN) {
          thisController.state.selectedServiceLineId =
            thisController.userDetails["serviceLineId"];
        }
        thisController.setState(thisController.state);
        thisController.fetchHealthSystemDetails();
      }
    } else {
      thisController.state.selectedHealthSystemId =
        localStorage.getItem("healthSystemId");
      thisController.state.selectedHospitalId =
        localStorage.getItem("hospitalId");
      thisController.state.selectedServiceLineId =
        localStorage.getItem("serviceLineId");
      var userRole = thisController.userDetails["userRole"];
      if (userRole == "ADMIN") {
        thisController.state.selectedHealthSystemId =
          localStorage.getItem("healthSystemId");
        thisController.state.selectedHospitalId =
          localStorage.getItem("hospitalId");
        thisController.state.selectedServiceLineId =
          localStorage.getItem("serviceLineId");
      } else if (userRole == "HEALTHSYSTEM_ADMIN") {
        thisController.state.selectedServiceLineId =
          localStorage.getItem("serviceLineId");
        thisController.state.selectedHealthSystemId =
          thisController.userDetails["healthSystemId"];
        thisController.state.selectedHospitalId =
          localStorage.getItem("hospitalId");
      } else {
        thisController.state.selectedServiceLineId =
          localStorage.getItem("serviceLineId");
        thisController.state.selectedHealthSystemId =
          thisController.userDetails["healthSystemId"];
        thisController.state.selectedHospitalId =
          thisController.userDetails["hospitalId"];
      }

      if (window.SCOPE_VALUE.CURRENT <= window.SCOPE_VALUE.SERVICELINE_ADMIN) {
        thisController.state.selectedServiceLineId =
          thisController.userDetails["serviceLineId"];
      }
      thisController.setState(thisController.state);
      thisController.fetchHealthSystemDetails();
    }
  }

  componentWillUnmount() {
  clearTimeout(this.searchDebounceTimer); 
}


  fetchHealthSystemDetails() {
    var thisController = this;
    var responseData = [];
    var healthSystemId;
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HOSPITAL_ADMIN") {
      thisController.state.healthSystemId =
        thisController.userDetails["healthSystemId"];
    } else {
      healthSystemId = document.getElementById("healthSystem").value;
    }
    $.ajax({
      url: "/my-jeeva-api/health-system",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.healthSystemGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.healthSystemGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          thisController.setState(thisController.state);

          if (!thisController.state.selectedHealthSystemId) {
            var healthSystemsDropDownList =
              thisController.healthSystemDropDownInProcedureRef.current;

            if (healthSystemsDropDownList) {
              thisController.state.selectedHealthSystemId =
                healthSystemsDropDownList.value;
              thisController.state.selectedHospitalId = null;
              thisController.state.selectedServiceLineId = null;
              // setTimeout(() => (thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInProcedureRef.current })), 100);
            } else {
              thisController.state.selectedHealthSystemId = res.result[0].id;
              thisController.state.selectedHospitalId = null;
              thisController.state.selectedServiceLineId = null;
              // setTimeout(() => (thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInProcedureRef.current })), 100);
            }
          }

          thisController.setState(thisController.state);

          var selectBox =
            thisController.healthSystemDropDownInProcedureRef.current;
          if (selectBox && selectBox.selectedIndex >= 0) {
            thisController.onHealthSystemChange({ target: selectBox });
          }

          thisController.fetchHospitalDetails();
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no procedures present. </p>
    </div>
  );

  fetchHospitalDetails() {
    var thisController = this;
    var responseData = [];
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
    }
    $.ajax({
      url: "/my-jeeva-api/hospital",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.hospitalGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.hospitalGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          thisController.setState(thisController.state);
          if (!thisController.state.selectedHospitalId) {
            thisController.state.selectedServiceLineId = null;
            if (totalCount > 0) {
              thisController.state.selectedHospitalId = res.result[0].id;
              setTimeout(() => {
                thisController.onHospitalChange({
                  target: thisController.hospitalDropDownInProcedureRef.current,
                });
              }, 100);
            } else {
              thisController.state.selectedHospitalId = null;
            }
          }
          thisController.setState(thisController.state);

          /*  var selectBox = thisController.hospitalDropDownInProcedureRef.current;
            if (selectBox && selectBox.selectedIndex >= 0) {
              thisController.onHospitalChange({ target: selectBox });
            } */

          thisController.fetchServiceLineDetails();
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }
  // code for dragabble
  handleMouseDown = (e) => {
    e.preventDefault();
    const { clientX, clientY } = e;
    const rect = e.currentTarget.getBoundingClientRect();
    this.setState({
      isDragging: true,
      modalStartPosition: { x: rect.left, y: rect.top },
      cursorStartPosition: { x: clientX, y: clientY }
    });
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  handleMouseMove = (e) => {
    if (this.state.isDragging) {
      const { clientX, clientY } = e;
      const deltaX = clientX - this.state.cursorStartPosition.x;
      const deltaY = clientY - this.state.cursorStartPosition.y;
      this.setState(prevState => ({
        modalPosition: {
          x: prevState.modalPosition.x + deltaX,
          y: prevState.modalPosition.y + deltaY
        },
        cursorStartPosition: { x: clientX, y: clientY }
      }));
    }
  }

  handleMouseUp = () => {
    this.setState({ isDragging: false });
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  fetchServiceLineDetails() {
    var responseData = [];
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
    }
    if (hospitalId == "null" || hospitalId == null) {
      hospitalId = "00000000-0000-0000-0000-000000000000";
    }
    $.ajax({
      url: "/my-jeeva-api/service-line",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.serviceLineGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.serviceLineGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          thisController.setState(thisController.state);

          if (!thisController.state.selectedServiceLineId) {
            if (totalCount > 0) {
              thisController.state.selectedServiceLineId = res.result[0].id;
              setTimeout(() => {
                if (thisController.serviceLineDropDownInProcedureRef.current) {
                  thisController.onServiceLineChange({
                    target:
                      thisController.serviceLineDropDownInProcedureRef.current,
                  });
                }
              }, 100);
            } else {
              thisController.state.selectedServiceLineId = null;
            }
          }
          thisController.fetchProcedureDetails();
          thisController.setState(thisController.state);
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  notifyFailedLoad(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  fetchProcedureDetails = () => {
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var procedureIds = [];
    var providerId;
    if (userRole == "ADMIN") {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "SERVICELINE_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else if (userRole == "PHYSICIAN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
      procedureIds[thisController.userDetails["procedureId"]] = true;
      providerId = thisController.userDetails["userId"];
    }
    if (hospitalId == "null" || hospitalId == null) {
      hospitalId = "00000000-0000-0000-0000-000000000000";
    }
    if (serviceLineId == "null" || serviceLineId == null) {
      serviceLineId = "00000000-0000-0000-0000-000000000000";
    }

    if (userRole == "PHYSICIAN") {
      $.ajax({
        url: "/my-jeeva-api/procedure-treatment",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: providerId,
          hospitalId: hospitalId,
          serviceLineId: serviceLineId,
        },
        success: function (res) {
          if (res.success === true) {
            if (res.result.length == 0) {
              thisController.state.noTreatments = true;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.allData = res.result;
              if (thisController.state.allData.length > 0) {
                thisController.checkTreatmentStatusBatch(thisController.state.allData);
                thisController.checkTranslationApprovalStatusBatch(thisController.state.allData);
              }
              thisController.state.noMatchingData = false;
              thisController.state.isLoading = false;
              thisController.state.disabled = false;
              thisController.state.showLoader = true;
              thisController.setState(thisController.state);
              thisController.filterActiveProcedures();
            }
          } else {
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            tokenVerification();
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/procedure",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          serviceLineId: serviceLineId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.allData = res.result;
            if (thisController.state.allData.length > 0) {
              thisController.checkTreatmentStatusBatch(thisController.state.allData);
              thisController.checkTranslationApprovalStatusBatch(thisController.state.allData);
            }
            thisController.state.disabled = false;
            thisController.state.isLoading = false;
            thisController.state.noMatchingData = false;
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            thisController.filterActiveProcedures();
          } else {
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            tokenVerification();
          }
        },
      });
    }
  };

  handleCheckBoxChange = (e) => {
    // this.setState({ pageNum: 1 });
    this.state.pageNum = 1;
    localStorage.setItem("lastActivePageNum", 1);
    // this.fetchProcedureDetails();
    var treatments = [];
    var checkbox = e.target.checked;
    // var checkbox = document.getElementById("deactivated").checked;
    this.state.discontinued = !this.state.discontinued;

    if (checkbox === false) {
      for (let i = 0; i < this.state.allData.length; i++) {
        if (
          this.state.allData[i].isDeactivated == false ||
          this.state.allData[i].isDeactivated == null
        ) {
          treatments.push(this.state.allData[i]);
        }
      }
    } else {
      for (let i = 0; i < this.state.allData.length; i++) {
        if (this.state.allData[i].isDeactivated == true) {
          treatments.push(this.state.allData[i]);
        }
      }
    }

    this.state.data = treatments;
    this.setState(this.state);
    console.log("Active Procedure page Number : ", this.state.pageNum);
  };

  filterActiveProcedures = () => {
    var treatments = [];

    if (this.state.discontinued === false) {
      for (let i = 0; i < this.state.allData.length; i++) {
        if (
          this.state.allData[i].isDeactivated == false ||
          this.state.allData[i].isDeactivated == null
        ) {
          treatments.push(this.state.allData[i]);
        }
      }
    } else {
      for (let i = 0; i < this.state.allData.length; i++) {
        if (this.state.allData[i].isDeactivated == true) {
          treatments.push(this.state.allData[i]);
        }
      }
    }

    this.setState({
      data: treatments,
      pageNum: this.restoredPage || 1,
      tableReady: true,
    }, () => {
      // console.log("=== FILTER: setState done, pageNum ===", this.state.pageNum);
      // console.log("=== FILTER: tableReady ===", this.state.tableReady);
    });
  };

  fetchTreatments = () => {
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "ADMIN") {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = document.getElementById("hospitalDropDown").value;
      serviceLineId = document.getElementById("serviceLine").value;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "SERVICELINE_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else if (userRole == "PHYSICIAN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    }

    $.ajax({
      url: "/my-jeeva-api/fetch-survey-group",
      method: "GET",
      data: {
        surveyScope: "TREATMENT",
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
        serviceLineId: serviceLineId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          if (res.success === true) {
            // thisController.state.data = res.result;
            thisController.filterActiveProcedures();
            thisController.state.disabled = false;
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
          } else {
            // thisController.notifyError(res.result);
          }
        }
      },
    });
  };

  saveTreatmentDetails(row, e) {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    var UserEmail = thisController.userDetails["emailId"];

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = document.getElementById("hospitalDropDown").value;
      serviceLineId = document.getElementById("serviceLine").value;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = document.getElementById("serviceLine").value;
    } else if (userRole == "SERVICELINE_ADMIN" || userRole == "PHYSICIAN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (healthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else if (hospitalId == "null" || hospitalId == null) {
      thisController.notifySelectHospital();
    } else if (serviceLineId == "null" || serviceLineId == null) {
      thisController.notifySelectServiceLine();
    } else {
      var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
      row.name = document.getElementById("name" + row.id).innerText.trim() || thisController.state.editedName.trim();
      row.description = document
        .getElementById("description" + row.id)
        .innerText.trim();

      if (row.name == "") {
        thisController.notifyEmptyFields();
      } else if (!namePattern.test(row.name)) {
        thisController.notifyImproperName();
      } else {
        thisController.state.editedId = "-1";
        this.state.dataStartedProcessing = true;
        thisController.setState(thisController.state);
        var saveData = {
          name: row.name,
          description: row.description,
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          serviceLineId: serviceLineId,
          createdBy: UserEmail
        };

        var timer = setInterval(function () {
          clearTimeout(timer);

          $.ajax({
            url: "/my-jeeva-api/procedure",

            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
            },
            data: JSON.stringify(saveData),
            success: function (res) {
              if (res.success === true) {
                thisController.state.dataStartedProcessing = false;
                thisController.fetchProcedureDetails();
                thisController.state.disabled = false;
                thisController.setState(thisController.state);
              } else {
                thisController.notifyFailedResponse(res.result);
              }
            },
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.href = "";
              }
            },
          });
        }, 2000);
      }
    }
  }

  checkForSameTreatments(newTreatmentName) {
    var existingTreatments = this.state.data;

    for (var i = 0; i < existingTreatments.length; i++) {
      if (existingTreatments[i].name == newTreatmentName) {
        return true;
      }
    }

    return false;
  }

  updateTreatmentDetails = (props, e) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    var isDeactivated = props.isDeactivated;
    var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN" ||
      userRole == "NURSE"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (healthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else if (hospitalId == "null" || hospitalId == null) {
      thisController.notifySelectHospital();
    } else if (serviceLineId == "null" || serviceLineId == null) {
      thisController.notifySelectServiceLine();
    } else {
      // var editedDescription = document.getElementById("description" + props.id).innerText.trim();
      // var editedName = document.getElementById("name" + props.id).innerText.trim();
      if (thisController.state.cloning === true) {
        // thisController.makeCelledit(props);
        var editedName = props.name;
        var editedDescription = props.description;
      } else {
        var editedName = thisController.state.editedName.trim();
        var editedDescription = thisController.state.editedDescription.trim();
      }

      var updateController = this;
      if (editedName == "") {
        updateController.notifyEmptyFields();
      } else if (!namePattern.test(editedName)) {
        updateController.notifyImproperName();
      } else {
        var updatedData = {
          id: props.id,
          name: editedName,
          description: editedDescription,
          serviceLineId: serviceLineId,
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          isDeactivated: isDeactivated,
        };
        $.ajax({
          url: "/my-jeeva-api/procedure",
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
          },
          data: JSON.stringify(updatedData),
          contentType: "application/json; charset=UTF-8",
          success: function (res) {
            if (res.success === true) {
              updateController.state.editedId = "-1";
              updateController.state.cloning = false;
              // updateController.fetchProcedureDetails();
              updateController.refreshData();
            } else {
              updateController.notifyFailedResponse(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          },
        });
      }
    }
  };

  openContinueOrDiscontinuePopUp = (row, e) => {
    confirmAlert({
      title: this.state.discontinued
        ? "Confirm to Activate"
        : "Confirm to Deactivate",
      message: this.state.discontinued
        ? "Are you sure want to Activate this Treatment? Click on Inactive switch to view the Active Treatments."
        : "Do you want to Deactivate this Treatment? Click on Inactive switch to view the Deactivate Treatments.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.discontinued
              ? this.continueTreatment(row, e)
              : this.discontinueTreatment(row, e);
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  discontinueTreatment = (props, e) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN" ||
      userRole == "NURSE"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (healthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else if (hospitalId == "null" || hospitalId == null) {
      thisController.notifySelectHospital();
    } else if (serviceLineId == "null" || serviceLineId == null) {
      thisController.notifySelectServiceLine();
    } else {
      var editedName = document.getElementById("name" + props.id).innerText.trim();
      var editedDescription = document.getElementById("description" + props.id).innerText.trim();
      // var editedName = thisController.state.editedName;
      // var editedDescription = thisController.state.editedDescription;

      var updateController = this;
      if (editedName == "") {
        updateController.notifyEmptyFields();
      } else {
        var updatedData = {
          id: props.id,
          name: editedName,
          description: editedDescription,
          serviceLineId: serviceLineId,
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          isDeactivated: true,
        };
        $.ajax({
          url: "/my-jeeva-api/procedure",
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
          },
          data: JSON.stringify(updatedData),
          contentType: "application/json; charset=UTF-8",
          success: function (res) {
            if (res.success === true) {
              updateController.state.editedId = "-1";
              updateController.fetchProcedureDetails();
            } else {
              updateController.notifyFailedResponse(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          },
        });
      }
    }
  };
  continueTreatment = (props, e) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN" ||
      userRole == "NURSE"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (healthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else if (hospitalId == "null" || hospitalId == null) {
      thisController.notifySelectHospital();
    } else if (serviceLineId == "null" || serviceLineId == null) {
      thisController.notifySelectServiceLine();
    } else {
      var editedName = document.getElementById("name" + props.id).innerText.trim();
      var editedDescription = document.getElementById("description" + props.id).innerText.trim();
      // var editedName = thisController.state.editedName;
      // var editedDescription = thisController.state.editedDescription;

      var updateController = this;
      if (editedName == "") {
        updateController.notifyEmptyFields();
      } else {
        var updatedData = {
          id: props.id,
          name: editedName,
          description: editedDescription,
          serviceLineId: serviceLineId,
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          isDeactivated: false,
        };
        $.ajax({
          url: "/my-jeeva-api/procedure",
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
          },
          data: JSON.stringify(updatedData),
          contentType: "application/json; charset=UTF-8",
          success: function (res) {
            if (res.success === true) {
              updateController.state.editedId = "-1";
              updateController.fetchProcedureDetails();
            } else {
              updateController.notifyFailedResponse(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          },
        });
      }
    }
  };

  deleteTreatmentDetails = (id) => {
    let procedureData = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      procedureData.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-procedure/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            procedureData.splice(id, 1);
            deleteApiViewController.refreshData();
          } else {
            // procedureData.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }

    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchProcedureDetails();
  };
  cloneTreatment = (row) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var UserEmail = thisController.userDetails["emailId"];
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    var providerId;
    var providerName;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "SERVICELINE_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else if (userRole == "PHYSICIAN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
      providerId = thisController.userDetails["userId"];
      providerName = thisController.userDetails["name"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (healthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else if (hospitalId == "null" || hospitalId == null) {
      thisController.notifySelectHospital();
    } else if (serviceLineId == "null" || serviceLineId == null) {
      thisController.notifySelectServiceLine();
    } else {
      row.name = document.getElementById("name" + row.id).innerText.trim();
      row.description = document.getElementById("description" + row.id).innerText.trim();

      if (row.name == "") {
        thisController.notifyEmptyFields();
      } else {
        this.state.editedId = "-1";
        var saveData = {
          name: row.name,
          description: row.description,
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          serviceLineId: serviceLineId,
          id: row.id,
          createdBy: UserEmail
        };
        // var saveDataProvider = { name: row.name,
        //   description: row.description,
        //   healthSystemId: healthSystemId,
        //   hospitalId: hospitalId,
        //   serviceLineId: serviceLineId,
        //   id: row.id,

        // };
        if (userRole == "PHYSICIAN") {
          $.ajax({
            url: "/my-jeeva-api/clone-treatment-byProvider",

            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            data: {
              name: row.name,
              description: row.description,
              healthSystemId: healthSystemId,
              hospitalId: hospitalId,
              serviceLineId: serviceLineId,
              id: row.id,
              providerName: providerName,
              providerId: providerId,
              createdBy: UserEmail
            },

            success: function (res) {
              if (res.success === true) {
                thisController.state.fromClone = true;
                if (thisController.state.providerOwnTreatmentIds !== null) {
                  thisController.state.providerOwnTreatmentIds = thisController.state.providerOwnTreatmentIds.concat(res.result);
                }
                thisController.setState(thisController.state);
                thisController.state.editableModeOn = true;
                thisController.state.clonedId = res.result;
                thisController.makeCelledit(res.result);
                thisController.setState(thisController.state);
                thisController.notifyTreatmentCloned();
                thisController.refreshData(res.result);
                thisController.fetchProcedureDetails();
                thisController.state.disabled = false;
                thisController.setState(thisController.state);
              } else {
                thisController.state.editableModeOn = true;
                thisController.setState(thisController.state);
                if (res.result) {
                  thisController.notifyFailedResponse(res.result);
                }
                thisController.refreshData();
                thisController.fetchProcedureDetails();
                thisController.state.disabled = false;
                thisController.setState(thisController.state);
              }
            },
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.href = "";
              }
            },
          });
        } else {
          $.ajax({
            url: "/my-jeeva-api/clone-treatment",

            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
            },
            data: JSON.stringify(saveData),

            success: function (res) {
              if (res.success === true) {
                thisController.state.fromClone = true;
                thisController.setState(thisController.state);
                thisController.state.editableModeOn = true;
                thisController.state.clonedId = res.result;
                thisController.makeCelledit(res.result);
                thisController.setState(thisController.state);
                thisController.notifyTreatmentCloned();
                thisController.refreshData(res.result);
                thisController.fetchProcedureDetails();
                thisController.state.disabled = false;
                thisController.setState(thisController.state);
              } else {
                thisController.state.editableModeOn = true;
                // thisController.state.clonedId = res.result;
                // thisController.makeCelledit(res.result);
                thisController.setState(thisController.state);
                if (res.result) {
                  thisController.notifyFailedResponse(res.result);
                }
                thisController.refreshData();
                thisController.fetchProcedureDetails();
                thisController.state.disabled = false;
                thisController.setState(thisController.state);
              }
            },
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.href = "";
              }
            },
          });
        }
      }
    }
  };

  addNewProcedure = () => {
    var addController = this;
    addController.state.paginationValue =
      addController.state.paginationValue + 5;

    if (addController.state.pageNum != 0) {
      addController.setState({ pageNum: 0 });
    }
    this.state.data.unshift({
      id: "",
      name: "",
      description: "",
    });
    this.setState({
      noMatchingData: false,
      data: this.state.data,
      disabled: true,
    });
  };
  notifySelectHealthSystem() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Health System
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchProviderOwnTreatmentIds = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/provider-own-treatment-ids",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        providerId: thisController.userDetails["userId"],
      },
      success: function (res) {
        if (res.success === true) {
          thisController.setState({ providerOwnTreatmentIds: res.result });
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  };

  // Owner to compare against for the provider's read-only checks. A user with both an admin and a provider role
  // has one email, so a treatment they created as admin is only their own if they cloned it as a provider.
  providerOwner = (row) => {
    var ownIds = this.state.providerOwnTreatmentIds;
    if (this.userDetails["userRole"] !== "PHYSICIAN" || ownIds === null) {
      return row.createdBy;
    }
    return ownIds.includes(row.id) ? row.createdBy : "";
  };

  navigateToLibrary(treatmentName, treatmentId, createdBy) {
    localStorage.setItem("createdBy", createdBy);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastActivePageNum", pageToSave);

    this.props.history.push({
      pathname: "/projectmgmt/treatment-content-library",
      state: {
        treatmentName: treatmentName,
        treatmentId: treatmentId,
      },
    });
  }

  notifySelectHospital() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Hospital
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperName() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid name
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperDescription() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Kindly avoid special characters & provide a valid
        description.
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectServiceLine() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Service Line
      </b>,
      {
        position: "top-center",
      }
    );
  }

  /*
    makeCelledit(row, e) {
      var thisRow = row;
      var controller = this;
        function edit(thisRow, e) {
          controller.markAsBeingEdited(thisRow.id);
          controller.state.editedName = thisRow.name;
          controller.state.editedDescription = thisRow.description;
          controller.setState(controller.state);
        }
      return edit;
    }
  */

  makeCelledit(row, e) {
    this.markAsBeingEdited(row.id);
    if (this.state.fromClone) {
      this.state.fromClone = false;
      this.setState(this.state);
      return;
    }
    this.state.editedName = row.name;
    this.state.editedDescription = row.description;
    this.setState(this.state);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }
  refreshData = (id) => {
    this.state.editedId = id;
    this.state.isLoading = true;
    this.state.noMatchingData = false;
    this.state.data = [];
    this.state.disabled = false;
    this.state.searchTerm = ""
    this.setState(this.state);
    this.fetchProcedureDetails();
  };

  notifyProcedureAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Treatment detail added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyTreatmentCloned() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Treatment cloned successfully. Kindly rename the newly
        cloned treatment.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyProcedureUpdated() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Treatment details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Treatment details deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyPassPhraseSaved() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Passphrase saved successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyPassPhraseDeleted() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Passphrase deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyInvalidEntry() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Sorry, that's not a valid input
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{response}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDataProcessing() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Hold on.Your data is saving...
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notify(message) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyWarning(message) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  onPageChange = (e) => {
    this.restoredPage = e;
    this.setState({ pageNum: e });
    localStorage.setItem("lastActivePageNum", e);
  };

  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  handleChangeForLanguage = (event) => {
    this.setState({
      value: event.target.value,
    });
    this.fetchProcedureDetails();
  };

  paintHeading = () => {
    var healthSystemName = localStorage.getItem("healthSystemName");
    var hospitalName = localStorage.getItem("hospitalName");
    var serviceLineName = localStorage.getItem("serviceName");

    if (hospitalName == "Select Hospital" || hospitalName == "null") {
      hospitalName = null;
    }
    if (serviceLineName == "Select Service Line" || serviceLineName == "null") {
      serviceLineName = null;
    }

    var heading = "";
    if (healthSystemName) {
      heading = healthSystemName;
      if (hospitalName) {
        heading = hospitalName + " | " + heading;
        if (serviceLineName) {
          heading = serviceLineName + " | " + heading;
        }
      }
    }
    this.state.topHeading = heading;
    this.setState(this.state);
  };

  notifyEmptyField() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  onHealthSystemChange = (e) => {
    var selectBox = e.target;
    this.state.isLoading = true;
    var userRole = this.userDetails["userRole"];
    this.state.dontOverLap = true;
    if (this.state.selectedHealthSystemId != selectBox.value) {
      this.state.selectedHospitalId = null;
      localStorage.setItem(`hospitalName`, null);
      localStorage.setItem(`hospitalId`, null);
      localStorage.setItem("serviceName", null);
      localStorage.setItem("serviceLineId", null);
    }
    this.state.selectedHealthSystemId = selectBox.value;
    localStorage.setItem("healthSystemId", this.state.selectedHealthSystemId);
    if (selectBox.value != "") {
      var healthSystemName =
        selectBox.options[selectBox.selectedIndex].innerText;
      localStorage.setItem("healthSystemName", healthSystemName);
    }
    this.setState(this.state);
    if (userRole != "PHYSICIAN") {
      window.adminNavigationBar.paintHeading();
    }
    this.fetchHospitalDetails();
  };

  onHospitalChange = (e) => {
    var selectBox = e.target;
    this.state.isLoading = true;
    var userRole = this.userDetails["userRole"];
    this.state.dontOverLap = true;
    if (this.state.selectedHospitalId != selectBox.value) {
      this.state.selectedServiceLineId = null;
      localStorage.setItem("serviceName", null);
      localStorage.setItem("serviceLineId", null);
    } else {
      console.log(
        "Selected Hospital ID=" +
        this.state.selectedHospitalId +
        " which is same as the current selection which is:" +
        selectBox.value
      );
    }
    this.state.selectedHospitalId = selectBox.value;
    localStorage.setItem("hospitalId", this.state.selectedHospitalId);
    if (selectBox.value != "") {
      var hospitalName = selectBox.options[selectBox.selectedIndex].innerText;
      localStorage.setItem("hospitalName", hospitalName);
    }
    this.setState(this.state);
    if (userRole != "PHYSICIAN") {
      window.adminNavigationBar.paintHeading();
    }
    this.fetchServiceLineDetails();
  };

  onServiceLineChange = (e) => {
    var selectBox = e.target;
    this.state.isLoading = true;
    var userRole = this.userDetails["userRole"];

    this.state.dontOverLap = true;
    this.state.selectedServiceLineId = e.target.value;
    localStorage.setItem("serviceLineId", this.state.selectedServiceLineId);
    if (e.target.value != "") {
      var serviceLineName =
        e.target.options[e.target.selectedIndex].innerText;
      localStorage.setItem("serviceName", serviceLineName);
    }
    this.setState(this.state);
    if (userRole != "PHYSICIAN") {
      window.adminNavigationBar.paintHeading();
    }
    this.fetchProcedureDetails();
  };

  openDeletePopUp = (id) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: "Are you sure to delete this? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteTreatmentDetails(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  generateQRCode = (row) => {
    this.checkContentPublished(row.id)
      .then((res) => {
        if (res.success === true) {

          const userRole = this.userDetails["userRole"];
          if (window.SCOPE_VALUE.CURRENT < window.SCOPE_VALUE.PHYSICIAN) {
            this.notifyFailedResponse(
              "QR code should be generated only by the Provider or Higher Role"
            );
            return;
          }
          localStorage.setItem("procedureName", row.name);
          $.ajax({
            url: "/my-jeeva-api/generate-qrcode-treatment-provider",
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
              treatmentId: row.id,
              providerId: this.userDetails["userId"],
            },
            success: (res) => {
              if (res.success === true) {
                this.setState({
                  treatmentId: row.id,
                  showQrCode: true,
                  qrCode: res.result,
                  disabled: false,
                });
              } else {
                this.notifyFailedResponse(res.result);
              }
            },
            error: (xhr) => {
              if (xhr.status === 401) {
                window.location.href = "";
              }
            },
          });

        } else {
          this.notifyPublishLibrary(row);
        }
      })
      .catch((xhr) => {
        if (xhr.status === 401) {
          tokenVerification();
        }
      });
  };

  // An unpublished library cannot be shared with a patient - the dialog cannot be
  // dismissed, so the only way on from here is Continue, which opens the library
  notifyPublishLibrary = (row) => {
    const goToLibrary = () =>
      this.navigateToLibrary(row.name, row.id, this.providerOwner(row));
    confirmAlert({
      title: "Publish library",
      message:
        "Please publish the library prior to sharing the treatment with a patient. Treatment libraries are published via the slider toggle on the upper right corner of the treatment library page.",
      buttons: [
        {
          label: "Continue",
          onClick: goToLibrary,
        },
      ],
      closeOnClickOutside: false,
      closeOnEscape: false,
    });
  };


  fetchPredefinedMileStones() {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/get-predefined-milestones",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true && thisController.state.showTreatmentMileStones) {
          thisController.state.predefinedMileStones = res.result.map(m => ({
            value: m.name,
            label: m.name
          }));
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }


  closeQrCodePage = () => {
    localStorage.removeItem("procedureName");
    this.setState({ showQrCode: false });
  };
  handleStart(event, data) {
    console.log('Dragging started');
    console.log('Initial position:', data.x, data.y);
  };
  handleDrag(event, data) {
    console.log('Dragging');
  };
  handleStop(event, data) {
    console.log('Dragging stopped');

  }
  openClonePopUp = (row) => {

    confirmAlert({
      title: 'Confirm to clone treatment ',
      message: 'Are you sure you want to clone this treatment ? ',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.handleClonedData(row)
        },
        {
          label: 'No',
        }
      ]
    });
  }
  handleClonedData = (row) => {
    this.cloneTreatment(row);
    this.state.cloning = true;
    this.state.editableModeOn = true;
    this.state.editedId = this.state.clonedId;
    // this.makeCelledit(row);
    var stateObj = this.state;
    this.setState(stateObj);
  };

  handleDescriptionChange = (e, props) => {
    this.state.editedDescription = e.currentTarget.textContent;
    if (this.state.cloning == true) {
      this.state.editedName = props.name;
      this.state.cloning = false;
    }
    this.setState(this.state);
  };
  handleNameChange = (e, props) => {
    this.state.editedName = e.currentTarget.textContent;
    if (this.state.cloning == true) {
      this.state.editedDescription = props.description;
      this.state.cloning = false;
    }
    this.setState(this.state);
  };

  moveCursorToEnd(e) {
    let placeholderText = e.target.innerText;
    e.target.innerText = '';
    e.target.innerText = placeholderText;

    // Collapse to the end instead of offsetting into firstChild: after the name is cleared
    // the box holds a <br>, which has no child at any offset and threw IndexSizeError.
    if (document.createRange) {
      let range = document.createRange();
      let selection = window.getSelection();
      range.selectNodeContents(e.target);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  addPassPhrase = (row, e) => {
    this.checkContentPublished(row.id)
      .then((res) => {
        if (res.success === true) {

          localStorage.setItem("createdBy", this.providerOwner(row));
          localStorage.setItem("procedureName", row.name);

          this.setState({
            showPassPhrase: true,
            treatmentId: row.id,
            passPhrase: ""
          }, () => {
            this.getPassPhrase(row.id);
            console.log("Treatment ID is " + this.state.treatmentId);
          });


        } else {
          this.notifyPublishLibrary(row);
        }
      })
      .catch((xhr) => {
        if (xhr.status === 401) {
          tokenVerification();
        }
      });
  };


  checkContentPublished = (treatmentId) => {
    return $.ajax({
      url: "/my-jeeva-api/check-content-published",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        treatmentId: treatmentId,
      }
    });
  };


  handlePassPhraseChange = (e) => {
    this.setState({ passPhrase: e.target.value });
  }

  getPassPhrase = (treatmentId) => {
    var thisController = this;
    thisController.state.passPhrase = "";
    thisController.setState(thisController.state);
    $.ajax({
      url: "/my-jeeva-api/get-pass-phrase",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        treatmentId: treatmentId,
        providerId: thisController.userDetails["userId"],
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.passPhrase = res.result.passPhrase;
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  savePassPhrase = () => {
    var passPhraseController = this;
    // Regex for empty or only special Characters
    var regex = "^(?:|[^a-zA-Z0-9]*)$";
    if (passPhraseController.state.passPhrase.match(regex)) {
      passPhraseController.notifyInvalidEntry();
    } else {
      var passPhraseData = {
        treatmentId: passPhraseController.state.treatmentId,
        providerId: passPhraseController.userDetails["userId"],
        passPhrase: passPhraseController.state.passPhrase.trim()
      }

      $.ajax({
        url: "/my-jeeva-api/pass-phrase",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(passPhraseData),
        contentType: "application/json; charset=UTF-8",

        success: function (res) {
          if (res.success === true) {
            passPhraseController.notifyPassPhraseSaved();
            passPhraseController.state.showPassPhrase = false;
            passPhraseController.state.passPhrase = "";
            passPhraseController.setState(passPhraseController.state);
          } else {
            passPhraseController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  }

  deletePassPhrase = () => {
    var passPhraseDeleteController = this;
    if (passPhraseDeleteController.state.passPhrase == "" || passPhraseDeleteController.state.passPhrase == null) {
      passPhraseDeleteController.notifyFailedResponse("No Pass-Phrase to Delete")
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-pass-phrase",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          treatmentId: passPhraseDeleteController.state.treatmentId,
          providerId: passPhraseDeleteController.userDetails["userId"],
        },

        success: function (res) {
          if (res.success === true) {
            passPhraseDeleteController.notifyPassPhraseDeleted();
            passPhraseDeleteController.state.showPassPhrase = false;
            passPhraseDeleteController.state.passPhrase = "";
            passPhraseDeleteController.setState(passPhraseDeleteController.state);
          } else {
            passPhraseDeleteController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            tokenVerification();
          }
        },
      });
    }
  }

  showAgentModal = (treatmentId, treatmentName, createdBy, virtualAgentId) => {
    var thisController = this;
    thisController.setState({ treatmentAgentName: "", treatmentAvatarName: "", treatmentAgentId: "" });
    thisController.state.showAgent = true;
    thisController.state.treatmentId = treatmentId;
    localStorage.setItem("createdBy", createdBy);
    thisController.setState(thisController.state);
    thisController.getAllAgents();
    thisController.getAllAvatars();
    if (virtualAgentId) {
      $.ajax({
        url: "/my-jeeva-api/get-procedure-agent",
        async: false,
        method: "GET",
        data: {
          procedureId: treatmentId
        },
        headers: {
          Authorization:
            "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },

        success: function (res) {
          if (res.success == true) {
            var virtualAgentInfo = res.result;
            if (virtualAgentInfo !== null) {
              thisController.setState({
                treatmentId: treatmentId,
                treatmentName: treatmentName,
                treatmentAgentId: virtualAgentId,
                treatmentAgentName: virtualAgentInfo.agentName,
                treatmentAvatarName: virtualAgentInfo.avatarName,
                enableAgent: virtualAgentInfo.enabled
              });
            }
          }
        },
      });

    } else {
      thisController.setState({
        treatmentId: treatmentId,
        treatmentName: treatmentName
      });
    }
  }

  getAllAgents = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/load-agents",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.agents = res.result;
          var agent;
          var agentMap = {};
          for (var i in res.result) {
            agent = res.result[i];
            if (agent.dheeProjectId === "b7b24390-d948-11ee-94a2-958162a89351") {
              agentMap[agent.id] = agent;
            }
          }
          thisController.agentMap = agentMap;
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  getAllAvatars = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/load-avatars",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.avatars = res.result;
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }


  saveAgent = () => {
    var thisController = this;
    let agentSelectionBox = document.getElementById("agentSelectionBox");
    let virtualAgentId = thisController.selectedAgentId;
    let virtualAgentName = thisController.selectedAgentName;
    let avatarName = thisController.selectedAvatar;
    var isEnabled = thisController.state.enableAgent;

    var row = {
      id: thisController.state.treatmentId,
    }

    if (!virtualAgentName) {
      virtualAgentName = thisController.state.treatmentAgentName;
      virtualAgentId = thisController.state.treatmentAgentId;
    }
    if (!avatarName) {
      avatarName = thisController.state.treatmentAvatarName;
    }

    console.log("agentId is = " + virtualAgentId + "agentName is = " + virtualAgentName);

    if (virtualAgentName != null && virtualAgentName != "Choose Agent") {
      var agentData = {
        agentId: virtualAgentId,
        agentName: virtualAgentName,
        avatarName: avatarName,
        procedureId: thisController.state.treatmentId,
        procedureName: thisController.state.treatmentName,
        isEnabled: isEnabled

      }

      $.ajax({
        url: "/my-jeeva-api/save-agent",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(agentData),
        success: function (res) {
          if (res.success === true) {
            thisController.notify(`${virtualAgentName} agent assigned to ${thisController.state.treatmentName}`);
            thisController.checkTreatmentStatus(row);
            thisController.setState({ showAgent: false });
          } else {
            thisController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    } else {
      thisController.notifyWarning("Please Choose an agent");
    }
  }

  getSlectedAgent = () => {
    if (this.state.selectedAgent == null || this.state.selectedAgent == "") {
      return "Currently no agent is saved.";
    } else {
      return <span><strong>{this.state.selectedAgent}</strong> is Applied to this treatment</span>
    }
  }

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    var a;
    var b;
    if (field === "admissionCount") {
      a = rowA[field] ? rowA[field] : "";
      b = rowB[field] ? rowB[field] : "";
    } else {
      a = rowA[field] ? rowA[field].toLowerCase() : '';
      b = rowB[field] ? rowB[field].toLowerCase() : '';
    }

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  // handleSearch = (event) => {
  //   var thisController = this;
  //   thisController.state.searchTerm = event.target.value;
  //   thisController.state.isLoading = true;
  //   thisController.state.data = [];
  //   if (thisController.state.searchTerm && thisController.state.searchTerm.length > 0) {
  //     if (!thisController.preSearchPage) {
  //       thisController.preSearchPage = thisController.state.pageNum || 1;
  //     }
  //     thisController.restoredPage = 1;
  //     thisController.state.pageNum = 1;
  //     localStorage.setItem("lastActivePageNum", 1);
  //   } else {
  //     const restoreTo = thisController.preSearchPage || 1;
  //     thisController.preSearchPage = null; 
  //     thisController.restoredPage = restoreTo;
  //     thisController.state.pageNum = restoreTo;
  //     localStorage.setItem("lastActivePageNum", restoreTo);
  //   }
  //   thisController.setState(thisController.state);

  //   var healthSystemId;
  //   var hospitalId;
  //   var serviceLineId;
  //   var thisController = this;
  //   var userRole = thisController.userDetails["userRole"];
  //   var procedureIds = [];
  //   var providerId;
  //   var Inactive = thisController.state.discontinued;
  //   if (userRole == "ADMIN") {
  //     healthSystemId = thisController.state.selectedHealthSystemId;
  //     hospitalId = thisController.state.selectedHospitalId;
  //     serviceLineId = thisController.state.selectedServiceLineId;
  //   } else if (userRole == "HEALTHSYSTEM_ADMIN") {
  //     healthSystemId = thisController.userDetails["healthSystemId"];
  //     hospitalId = thisController.state.selectedHospitalId;
  //     serviceLineId = thisController.state.selectedServiceLineId;
  //   } else if (userRole == "HOSPITAL_ADMIN") {
  //     healthSystemId = thisController.userDetails["healthSystemId"];
  //     hospitalId = thisController.userDetails["hospitalId"];
  //     serviceLineId = thisController.state.selectedServiceLineId;
  //   } else if (userRole == "SERVICELINE_ADMIN") {
  //     healthSystemId = thisController.userDetails["healthSystemId"];
  //     hospitalId = thisController.userDetails["hospitalId"];
  //     serviceLineId = thisController.userDetails["serviceLineId"];
  //   } else if (userRole == "PHYSICIAN") {
  //     healthSystemId = thisController.userDetails["healthSystemId"];
  //     hospitalId = thisController.userDetails["hospitalId"];
  //     serviceLineId = thisController.userDetails["serviceLineId"];
  //     procedureIds[thisController.userDetails["procedureId"]] = true;
  //     providerId = thisController.userDetails["userId"];
  //   }
  //   if (hospitalId == "null" || hospitalId == null) {
  //     hospitalId = "00000000-0000-0000-0000-000000000000";
  //   }
  //   if (serviceLineId == "null" || serviceLineId == null) {
  //     serviceLineId = "00000000-0000-0000-0000-000000000000";
  //   }
  //   if (providerId == "null" || providerId == null) {
  //     providerId = "00000000-0000-0000-0000-000000000000";
  //   }

  //   $.ajax({
  //     url: "/my-jeeva-api/search-procedure-data",
  //     method: "GET",
  //     data: {
  //       healthSystemId: healthSystemId,
  //       providerId: providerId,
  //       hospitalId: hospitalId,
  //       serviceLineId: serviceLineId,
  //       userRole: userRole,
  //       searchTerm: thisController.state.searchTerm,
  //       isDeactivated: Inactive
  //     },
  //     headers: {
  //       Authorization: "Bearer " + localStorage.getItem("access_token"),
  //     },

  //     success: function (res) {
  //       if (res.success === true) {
  //         if (res.result.length > 0) {
  //           thisController.state.data = [];
  //           thisController.setState(thisController.state);
  //           thisController.state.noMatchingData = false;
  //           thisController.state.isLoading = false;
  //           thisController.state.data = res.result;
  //           thisController.setState(thisController.state);
  //         } else {
  //           thisController.state.noMatchingData = true;
  //           thisController.state.isLoading = false;
  //           thisController.setState(thisController.state);
  //         }
  //       }
  //     },
  //     error: function (xhr) {

  //     },
  //   });

  // };

 handleSearch = (event) => {
  const thisController = this;
  const searchValue = event.target.value;

  const isFirstChar = thisController.state.searchTerm.trim() === "";
  const pageToSave = isFirstChar
    ? (thisController.state.pageNum || 1)
    : thisController.state.preSearchPage;

  thisController.setState({
    searchTerm: searchValue,
    preSearchPage: pageToSave,
  });

  if (searchValue.trim() === "") {
    clearTimeout(thisController.searchDebounceTimer);
    thisController.clearSearchData();
    return;
  }

  clearTimeout(thisController.searchDebounceTimer);
  thisController.searchDebounceTimer = setTimeout(() => {
    thisController.setState(prevState => ({
      pageNum: 1,
      tableKey: prevState.tableKey + 1,
      isLoading: true,
      data: [],
    }), () => {
      thisController.runSearch(searchValue);
    });
  }, 500);
};


  runSearch = (searchValue) => {
    const thisController = this;
    var healthSystemId, hospitalId, serviceLineId, providerId;
    var userRole = thisController.userDetails["userRole"];
    var Inactive = thisController.state.discontinued;

    if (userRole == "ADMIN") {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "SERVICELINE_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else if (userRole == "PHYSICIAN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
      providerId = thisController.userDetails["userId"];
    }

    if (!hospitalId || hospitalId == "null") hospitalId = "00000000-0000-0000-0000-000000000000";
    if (!serviceLineId || serviceLineId == "null") serviceLineId = "00000000-0000-0000-0000-000000000000";
    if (!providerId || providerId == "null") providerId = "00000000-0000-0000-0000-000000000000";

    $.ajax({
      url: "/my-jeeva-api/search-procedure-data",
      method: "GET",
      data: {
        healthSystemId, providerId, hospitalId,
        serviceLineId, userRole,
        searchTerm: searchValue,
        isDeactivated: Inactive,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.setState({
              noMatchingData: false,
              isLoading: false,
              data: res.result,
            });
          } else {
            thisController.setState({
              noMatchingData: true,
              isLoading: false,
            });
          }
        }
      },
      error: function (xhr) { },
    });
  };

  checkTreatmentStatusBatch = (rows) => {
    if (!rows || rows.length === 0) return;

    var statusController = this;
    var editorId = statusController.userDetails["userId"];
    var treatmentIds = rows.map(row => row.id);

    $.ajax({
      url: "/my-jeeva-api/treatment-status-batch?editorId=" + editorId,
      method: "POST",
      data: JSON.stringify(treatmentIds),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json"
      },
      dataType: "json",
      success: function (res) {
        if (res.success === true) {
          const statusMap = res.result;
          let newHighlightButtons = {};
          let newHighlightRuleButton = {};
          let newHighlightAgentButton = {};
          let newHighlightStandaloneReminder = {};
          let newHighlightMileStoneButton = {};

          for (const [treatmentId, status] of Object.entries(statusMap)) {
            newHighlightButtons[treatmentId] = status.hasContent || false;
            newHighlightRuleButton[treatmentId] = status.hasRule || false;
            newHighlightAgentButton[treatmentId] = status.hasAgent || false;
            newHighlightMileStoneButton[treatmentId] = status.hasMilestone || false;
            newHighlightStandaloneReminder[treatmentId] = status.hasStandaloneReminder || false;
          }

          statusController.setState(prevState => ({
            highlightButtons: {
              ...prevState.highlightButtons,
              ...newHighlightButtons
            },
            highlightRuleButton: {
              ...prevState.highlightRuleButton,
              ...newHighlightRuleButton
            },
            highlightAgentButton: {
              ...prevState.highlightAgentButton,
              ...newHighlightAgentButton
            },
            highlightMileStoneButton: {
              ...prevState.highlightMileStoneButton,
              ...newHighlightMileStoneButton
            },
            highlightStandaloneReminderButton: {
              ...prevState.highlightStandaloneReminderButton,
              ...newHighlightStandaloneReminder
            }
          }));
        }
      },
    });
  }

  checkTreatmentStatus = (row) => {
    this.checkTreatmentStatusBatch([row]);
  }

  checkTreatmentHasMilestone = (row) => {
    this.checkTreatmentStatusBatch([row]);
  }

  checkTranslationApprovalStatusBatch = (rows) => {
    if (!rows || rows.length === 0) return;

    var statusController = this;
    var treatmentIds = rows.map(row => row.id);

    $.ajax({
      url: "/my-jeeva-api/translation-approval/status-batch",
      method: "POST",
      data: JSON.stringify(treatmentIds),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json"
      },
      dataType: "json",
      success: function (res) {
        if (res.success === true) {
          const statusMap = res.result; // { treatmentId: "green" | "amber" | "red" }
          let newTranslationStatus = {};

          for (const [treatmentId, status] of Object.entries(statusMap)) {
            newTranslationStatus[treatmentId] = status;
          }

          console.log("[Translation Status Batch] Success:", newTranslationStatus);
          statusController.setState(prevState => ({
            translationApprovalStatus: {
              ...prevState.translationApprovalStatus,
              ...newTranslationStatus
            }
          }));
        }
      },
      error: function (xhr) {
        console.error("Error checking translation approval status:", xhr);
      }
    });
  }

  riskRulePage = (row) => {
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastActivePageNum", pageToSave);
    localStorage.setItem("procedureName", row.name);
    localStorage.setItem("procedureId", row.id);
    localStorage.setItem("healthSystemId", row.healthSystemId);
    localStorage.setItem("hospitalId", row.hospitalId);
    localStorage.setItem("serviceLineId", row.serviceLineId);
    localStorage.setItem("createdBy", this.providerOwner(row));

    this.props.history.push({
      pathname: "/projectmgmt/procedure/risk-rule",
    });
  };

  treatmentMileStoneModal = (row) => {
    localStorage.setItem("treatmentId", row.id);
    localStorage.setItem("treatmentName", row.name);
    this.state.selectedTreatmentForMilestone = row.name;
    this.state.selectedTreatmentCreatedBy = this.providerOwner(row);
    this.fetchMilestones();
    this.state.showTreatmentMileStones = true;
    this.setState(this.state);

  }

  getTranslationButtonColor = (treatmentId) => {
    const status = this.state.translationApprovalStatus[treatmentId];
    const isDiscontinued = this.state.discontinued;

    // Debug log
    console.log(`[Translation Color] Treatment: ${treatmentId}, Status: ${status}, All Status:`, this.state.translationApprovalStatus);

    if (isDiscontinued) {
      return "#282a6596";
    }

    switch (status) {
      case "green":
        return "rgb(5, 162, 47)"; // Green - All approvals done
      case "amber":
        return "rgb(239, 68, 68)"; // Red - Enabled language but partial approval/no approval done
      case "red":
        return "#282a65"; // Blue - No enabled language
      default:
        return "#282a65"; // Default blue
    }
  }

  navigateToTranslationManagement = (row) => {
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastActivePageNum", pageToSave);
    localStorage.setItem("procedureName", row.name);
    localStorage.setItem("procedureId", row.id);

    this.props.history.push({
      pathname: "/projectmgmt/translation-management",
      state: {
        procedureId: row.id,
        procedureName: row.name
      }
    });
  }

  handleChange = (newValue) => {
    console.log(newValue);
    this.setState({ selectedOptions: newValue || [] });
  };

  handleRemove = (value) => {
    const updatedOptions = this.state.selectedOptions.filter(
      (option) => option.value !== value
    );
    this.setState({ selectedOptions: updatedOptions });
  };

  saveMileStones = () => {
    var thisController = this;

    const labelsOnly = thisController.state.selectedOptions.filter(option => option.label.trim() !== '').map(option => option.label);

    // if(labelsOnly.length === 0) {
    //   thisController.notifyWarning("Please select treatment milestone or create custom milestone");
    // }
    var treatmentMilestoneModel = {
      data: labelsOnly,
      treatmentId: localStorage.getItem("treatmentId"),
      treatmentName: localStorage.getItem("treatmentName")
    };

    $.ajax({
      url: "/my-jeeva-api/save-milestone",

      method: "POST",
      contentType: "application/json; charset=utf-8",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: JSON.stringify(treatmentMilestoneModel),
      success: function (res) {
        if (res.success === true) {
          // thisController.state.showCreatbleSelect = false;
          thisController.state.inputValue = "";
          thisController.setState(thisController.state);
          thisController.fetchMilestones();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/login";
        }
      },
    });
  }

  handleInputChange = (e) => {
    this.state.inputValue = e;
    this.setState(this.state);
  }

  fetchMilestones = () => {
    var thisController = this;
    thisController.fetchPredefinedMileStones();

    $.ajax({
      url: "/my-jeeva-api/fetch-milestones",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        treatmentId: localStorage.getItem("treatmentId"),
      },
      success: function (res) {
        if (res.success === true && thisController.state.showTreatmentMileStones) {
          if (res.result.length > 0) {
            thisController.state.selectedMileStoneNames = res.result;
            thisController.state.showCreatbleSelect = false;
          } else {
            thisController.state.showCreatbleSelect = true;
          }
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/login";
        }
      },
    });
  }

  /* ------------------------------------------------------------------ *
   *  Stand-alone reminders                                               *
   * ------------------------------------------------------------------ */

  /**
   * The same rule the Library and the milestone window use: a provider can see the stand-alone
   * reminders of a treatment someone else (an admin) defined, but not change them.
   */
  isStandaloneReminderReadOnly = () => {
    if (this.userDetails["userRole"] !== "PHYSICIAN") return false;
    var userDetails = JSON.parse(localStorage.getItem('user_details'));
    return !userDetails || userDetails.emailId !== this.state.standaloneReminderCreatedBy;
  };

  standaloneReminderModal = (row) => {
    this.setState({
      showStandaloneReminders: true,
      standaloneReminderTreatmentId: row.id,
      standaloneReminderTreatmentName: row.name,
      standaloneReminderCreatedBy: row.createdBy,
      milestoneReminders: [],
      reminderMilestones: [],
      reminderMilestonesLoaded: false,
      editedReminderId: "-1",
      disableAddReminderButton: false,
    }, () => {
      this.fetchReminderMilestones(row.id);
      this.fetchMilestoneReminders(row.id);
      this.fetchReminderTranslationLanguages(row.id);
    });
  };

  closeStandaloneReminderModal = () => {
    this.setState({
      showStandaloneReminders: false,
      standaloneReminderTreatmentId: "",
      milestoneReminders: [],
      editedReminderId: "-1",
    });
  };

  fetchReminderMilestones = (treatmentId) => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/fetch-milestones",
      method: "GET",
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      data: { treatmentId: treatmentId },
      success: function (res) {
        if (res.success === true) {
          thisController.setState({ reminderMilestones: res.result || [], reminderMilestonesLoaded: true });
        }
      },
      error: function (xhr) { if (xhr.status == 401) { window.location.href = ""; } },
    });
  };

  fetchMilestoneReminders = (treatmentId) => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/fetch-milestone-reminders",
      method: "GET",
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      data: { treatmentId: treatmentId },
      success: function (res) {
        if (res.success === true) {
          var reminders = res.result || [];
          thisController.setState(prevState => ({
            milestoneReminders: reminders,
            editedReminderId: "-1",
            disableAddReminderButton: false,
            highlightStandaloneReminderButton: {
              ...prevState.highlightStandaloneReminderButton,
              [treatmentId]: reminders.length > 0,
            },
          }));
        }
      },
      error: function (xhr) { if (xhr.status == 401) { window.location.href = ""; } },
    });
  };

  addEmptyReminderRow = () => {
    var reminders = this.state.milestoneReminders.slice();
    reminders.unshift({
      id: "", milestoneId: "", milestoneName: "", offsetType: "SPECIFIC_TIME",
      dayOffset: 0, hourOffset: null, minuteOffset: null, timeOfDay: "", title: "", content: "",
    });
    this.setState({
      milestoneReminders: reminders,
      editedReminderId: "",
      disableAddReminderButton: true,
      reminderMilestoneId: "",
      reminderMilestoneName: "",
      reminderOffsetType: "SPECIFIC_TIME",
      reminderDayOffset: "0",
      reminderHourOffset: "0",
      reminderMinuteOffset: "0",
      reminderTimeOfDay: "",
      reminderTitle: "",
      reminderContent: "",
    });
  };

  markReminderAsBeingEdited = (row) => {
    this.setState({
      editedReminderId: row.id,
      reminderMilestoneId: row.milestoneId || "",
      reminderMilestoneName: row.milestoneName || "",
      reminderOffsetType: row.offsetType || "SPECIFIC_TIME",
      reminderDayOffset: String(row.dayOffset == null ? 0 : row.dayOffset),
      reminderHourOffset: String(row.hourOffset == null ? 0 : row.hourOffset),
      reminderMinuteOffset: String(row.minuteOffset == null ? 0 : row.minuteOffset),
      reminderTimeOfDay: row.timeOfDay || "",
      reminderTitle: row.title || "",
      reminderContent: row.content || "",
    });
  };

  handleReminderFieldChange = (field, e) => {
    if (field === "reminderMilestoneId") {
      var milestone = this.state.reminderMilestones.find((m) => m.id === e.target.value);
      this.setState({
        reminderMilestoneId: e.target.value,
        reminderMilestoneName: milestone ? milestone.mileStoneName : "",
      });
      return;
    }
    if (field === "reminderOffsetType") {
      // Each offset type ignores the other's field, so clear it rather than leave a stale value
      // sitting in a disabled input. This only touches the edit state: the row itself is left
      // alone, so leaving without saving (or refreshing) keeps what was stored.
      this.setState({
        reminderOffsetType: e.target.value,
        reminderTimeOfDay: e.target.value === "FLOATING_TIME" ? "" : this.state.reminderTimeOfDay,
        reminderHourOffset: e.target.value === "FLOATING_TIME" ? this.state.reminderHourOffset : "",
        reminderMinuteOffset: e.target.value === "FLOATING_TIME" ? this.state.reminderMinuteOffset : "",
      });
      return;
    }
    var stateObj = {};
    stateObj[field] = e.target.value;
    this.setState(stateObj);
  };

  /** Shows the nurse what the offsets actually mean before they save them. */
  reminderOffsetPreview = () => {
    var days = parseInt(this.state.reminderDayOffset, 10);
    if (isNaN(days)) days = 0;

    if (this.state.reminderOffsetType !== "FLOATING_TIME") {
      if (!this.state.reminderTimeOfDay) return "";
      return "e.g. a patient milestone with today's date fires at "
        + this.state.reminderTimeOfDay + " " + this.dayPhrase(days);
    }
    var hours = parseInt(this.state.reminderHourOffset, 10);
    if (isNaN(hours)) hours = 0;
    if (this.reminderMinutesError()) return this.reminderMinutesError();
    var extraMinutes = parseInt(this.state.reminderMinuteOffset, 10);
    if (isNaN(extraMinutes)) extraMinutes = 0;

    // Worked against a 14:00 milestone so the rollover is visible while typing.
    var minutes = days * 24 * 60 + hours * 60 + extraMinutes;
    var fromMidnight = 14 * 60 + minutes;
    var dayShift = Math.floor(fromMidnight / (24 * 60));
    var minuteOfDay = ((fromMidnight % (24 * 60)) + 24 * 60) % (24 * 60);
    var hh = String(Math.floor(minuteOfDay / 60)).padStart(2, "0");
    var mm = String(minuteOfDay % 60).padStart(2, "0");
    return "e.g. a patient milestone with today's date at 14:00 fires " + hh + ":" + mm + " " + this.dayPhrase(dayShift);
  };

  dayPhrase = (days) => {
    if (days === 0) return "the same day";
    if (days === 1) return "the next day";
    if (days === -1) return "the day before";
    return days > 0 ? days + " days after" : Math.abs(days) + " days before";
  };

  /**
   * Minutes carry only what is left over after the whole hours, so 90 is refused rather than
   * quietly turned into 1 hour 30 minutes - the nurse sees exactly what will be saved.
   */
  reminderMinutesError = () => {
    if (this.state.reminderOffsetType !== "FLOATING_TIME") return "";
    var minutes = parseInt(this.state.reminderMinuteOffset, 10);
    if (isNaN(minutes) || (minutes >= -59 && minutes <= 59)) return "";
    return "Minutes offset must be between -59 and 59. Use Hours offset for whole hours"
      + " (e.g. 90 minutes = 1 hour 30 minutes).";
  };

  saveMilestoneReminder = () => {
    var thisController = this;
    if (this.reminderMinutesError()) {
      this.notifyReminderFailed(this.reminderMinutesError());
      return;
    }
    if (!this.state.reminderMilestoneId || !this.state.reminderTitle.trim()
      || !this.state.reminderContent.trim()) {
      this.notifyReminderFieldEmpty();
      return;
    }
    if (this.state.reminderOffsetType === "SPECIFIC_TIME" && !this.state.reminderTimeOfDay) {
      this.notifyReminderFieldEmpty();
      return;
    }
    $.ajax({
      url: "/my-jeeva-api/save-milestone-reminder",
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(thisController.buildReminderPayload()),
      success: function (res) {
        if (res.success === true) {
          thisController.notifyReminderSaved();
          thisController.fetchMilestoneReminders(thisController.state.standaloneReminderTreatmentId);
        } else {
          thisController.notifyReminderFailed(res.result);
        }
      },
      error: function (xhr) { if (xhr.status == 401) { window.location.href = ""; } },
    });
  };

  updateMilestoneReminder = (row) => {
    var thisController = this;
    if (this.reminderMinutesError()) {
      this.notifyReminderFailed(this.reminderMinutesError());
      return;
    }
    if (!this.state.reminderTitle.trim() || !this.state.reminderContent.trim()) {
      this.notifyReminderFieldEmpty();
      return;
    }
    var payload = thisController.buildReminderPayload();
    payload.id = row.id;
    $.ajax({
      url: "/my-jeeva-api/update-milestone-reminder",
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
      success: function (res) {
        if (res.success === true) {
          thisController.notifyReminderSaved();
          thisController.fetchMilestoneReminders(thisController.state.standaloneReminderTreatmentId);
        } else {
          thisController.notifyReminderFailed(res.result);
        }
      },
      error: function (xhr) { if (xhr.status == 401) { window.location.href = ""; } },
    });
  };

  buildReminderPayload = () => {
    var isDayTime = this.state.reminderOffsetType === "FLOATING_TIME";
    return {
      treatmentId: this.state.standaloneReminderTreatmentId,
      milestoneId: this.state.reminderMilestoneId,
      milestoneName: this.state.reminderMilestoneName,
      offsetType: this.state.reminderOffsetType,
      dayOffset: parseInt(this.state.reminderDayOffset, 10) || 0,
      hourOffset: isDayTime ? (parseInt(this.state.reminderHourOffset, 10) || 0) : null,
      minuteOffset: isDayTime ? (parseInt(this.state.reminderMinuteOffset, 10) || 0) : null,
      timeOfDay: isDayTime ? null : this.state.reminderTimeOfDay,
      title: this.state.reminderTitle.trim(),
      content: this.state.reminderContent.trim(),
    };
  };

  openDeleteReminderPopUp = (row) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: `Are you sure you want to delete this reminder for ${row.milestoneName} ?`,
      buttons: [
        { label: "Yes", onClick: () => this.deleteMilestoneReminder(row.id) },
        { label: "No" },
      ],
      overlayClassName: "confirmAlertStyle",
    });
  };

  deleteMilestoneReminder = (id) => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/delete-milestone-reminder/" + id,
      method: "DELETE",
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          thisController.fetchMilestoneReminders(thisController.state.standaloneReminderTreatmentId);
        }
      },
      error: function (xhr) { if (xhr.status == 401) { window.location.href = ""; } },
    });
  };

  fetchReminderTranslationLanguages = (treatmentId) => {
    var thisController = this;
    $.ajax({
      url: `/my-jeeva-api/procedure/${treatmentId}/languages/enabled`,
      method: "GET",
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        var raw = (res && res.success === true && Array.isArray(res.result)) ? res.result : [];
        var languages = raw
          .filter((lang) => lang.code && lang.code.toLowerCase() !== "en")
          .map((lang) => ({
            code: lang.code.toLowerCase(),
            displayName: (lang.englishName || lang.displayName || lang.name)
              + " (" + (lang.name || lang.englishName) + ")",
          }));
        thisController.setState({ reminderTranslationLanguages: languages });
      },
      error: function () { thisController.setState({ reminderTranslationLanguages: [] }); },
    });
  };

  openReminderTranslationModal = (row) => {
    if (this.state.reminderTranslationLanguages.length === 0) {
      this.notifyReminderFailed("No other language is enabled for this treatment");
      return;
    }
    var first = this.state.reminderTranslationLanguages[0].code;
    this.setState({
      showReminderTranslationModal: true,
      selectedReminderForTranslation: row,
      selectedReminderLanguage: first,
      reminderTranslationFields: { title: "", content: "" },
    }, () => this.fetchReminderTranslation(row.id, first));
  };

  closeReminderTranslationModal = () => {
    this.setState({
      showReminderTranslationModal: false,
      selectedReminderForTranslation: null,
      reminderTranslationFields: { title: "", content: "" },
      reminderAutoTranslating: false,
    });
  };

  handleReminderLanguageChange = (e) => {
    this.setState({ selectedReminderLanguage: e.target.value });
    this.fetchReminderTranslation(this.state.selectedReminderForTranslation.id, e.target.value);
  };

  fetchReminderTranslation = (reminderId, language) => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/translation-edit/milestoneReminder/" + reminderId,
      method: "GET",
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      data: { language: language },
      success: function (res) {
        var fields = { title: "", content: "" };
        if (res.success === true && res.result && res.result.fields) {
          fields.title = res.result.fields.title || "";
          fields.content = res.result.fields.content || "";
        }
        thisController.setState({ reminderTranslationFields: fields });
        if (!fields.title && !fields.content) {
          thisController.autoTranslateReminder(language);
        }
      },
      error: function () { },
    });
  };

  autoTranslateReminder = (language) => {
    var thisController = this;
    var row = this.state.selectedReminderForTranslation;
    if (!row) return;
    this.setState({ reminderAutoTranslating: true });

    var translateField = (sourceText, fieldName) => new Promise((resolve) => {
      if (!sourceText) { resolve(); return; }
      $.ajax({
        url: "/my-jeeva-api/translation-edit/auto-translate?language=" + language
          + "&sourceText=" + encodeURIComponent(sourceText),
        method: "POST",
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true && res.result && res.result.translatedText) {
            var fields = Object.assign({}, thisController.state.reminderTranslationFields);
            fields[fieldName] = res.result.translatedText;
            thisController.setState({ reminderTranslationFields: fields });
          }
          resolve();
        },
        error: function () { resolve(); },
      });
    });

    Promise.all([
      translateField(row.title, "title"),
      translateField(row.content, "content"),
    ]).then(() => thisController.setState({ reminderAutoTranslating: false }));
  };

  handleReminderTranslationFieldChange = (fieldName, value) => {
    var fields = Object.assign({}, this.state.reminderTranslationFields);
    fields[fieldName] = value;
    this.setState({ reminderTranslationFields: fields });
  };

  saveReminderTranslation = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/translation-edit/milestoneReminder/"
        + this.state.selectedReminderForTranslation.id
        + "?language=" + this.state.selectedReminderLanguage,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(thisController.state.reminderTranslationFields),
      success: function (res) {
        if (res.success === true) {
          thisController.notifyReminderTranslationSaved();
          thisController.closeReminderTranslationModal();
        }
      },
      error: function () { thisController.notifyReminderFailed("Could not save the translation"); },
    });
  };

  notifyReminderFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: "0px", height: "20px", width: "20px" }} content="" />
      &nbsp;&nbsp;Please fill all the reminder fields</b>, { position: "top-center" });
  }

  notifyReminderSaved() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: "0px" }}
      content="" />&nbsp;&nbsp;Reminder saved successfully</b>, { position: "top-center" });
  }

  notifyReminderTranslationSaved() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: "0px" }}
      content="" />&nbsp;&nbsp;Translation has been saved successfully</b>, { position: "top-center" });
  }

  notifyReminderFailed(message) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{message || "Could not save the reminder"}</b>,
      { position: "top-center" });
  }

  handleCloseMilestoneModal = () => {
    this.state.showTreatmentMileStones = false;
    this.state.showCreatbleSelect = false;
    this.state.selectedMileStoneNames = []
    this.state.predefinedMileStones = []
    this.state.selectedOptions = [];
    this.state.selectedTreatmentCreatedBy = "";
    this.setState(this.state)
  }

  enableCreatbleSelect = (e) => {
    e.preventDefault();

    if (this.state.selectedMileStoneNames.length > 0) {
      var formattedOptions = this.state.selectedMileStoneNames.map((option) => ({
        value: option.mileStoneName,
        label: option.mileStoneName,
      }));
      this.state.selectedOptions = formattedOptions;

      const filteredPredefinedMilestones = this.state.predefinedMileStones.filter(
        (milestone) =>
          !formattedOptions.some(
            (option) => option.label === milestone.label
          )
      );
      this.state.predefinedMileStones = filteredPredefinedMilestones;
    }
    this.state.showCreatbleSelect = true;
    this.setState(this.state);
  }

  addAllOptionIfMissing = (callback) => {
    const { allPhysicians } = this.state;
    const alreadyExists = allPhysicians.some(
      (physician) => physician.userName === "All"
    );

    if (!alreadyExists) {
      this.setState(
        {
          allPhysicians: [{ id: "00000", userName: "All" }, ...allPhysicians],
        },
        callback
      );
    } else {
      callback();
    }
  };

  filterOptionChange = (event) => {
    const thisController = this;
    const targetValue = event.target.value;
    thisController.setState({ searchTerm: "" });

    if (targetValue === "myTreatments") {
      thisController.fetchProcedureDetails();
      var providerId = thisController.userDetails.userId
      localStorage.setItem("last-used-dropdown", "mine")
      thisController.setState({ selectedFilter: targetValue, selectedPhysicianId: providerId });

    } else if (targetValue === "allHospitalTreatments") {
      thisController.addAllOptionIfMissing(() => {
        thisController.fetchTreatmentsOfHospital("allHospital");
        localStorage.setItem("last-used-dropdown", "myHospital")
        thisController.setState({ selectedFilter: targetValue, selectedPhysicianId: "00000" });
      });
    } else if (targetValue === "allDepartmentTreatments") {
      thisController.addAllOptionIfMissing(() => {
        thisController.fetchTreatmentsOfDepartment("allDepartment");
        localStorage.setItem("last-used-dropdown", "myDepartment")
        thisController.setState({ selectedFilter: targetValue, selectedPhysicianId: "00000" });
      });
    } else {
      thisController.setState({ selectedFilter: targetValue, selectedPhysicianId: "" });
    }
  };

  fetchTreatmentsOfHospital() {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/all-treatments-in-hospital",
      method: "GET",
      data: {
        hospitalId: thisController.userDetails["hospitalId"]
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.allData = res.result;
          if (thisController.state.allData.length > 0) {
            thisController.checkTreatmentStatusBatch(thisController.state.allData);
          }
          thisController.state.disabled = false;
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          thisController.filterActiveProcedures();
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva-api/login";
        }
      },
    });
  }

  fetchTreatmentsOfDepartment() {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/all-treatments-in-department",
      method: "GET",
      data: {
        serviceLineId: thisController.userDetails["serviceLineId"]
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.allData = res.result;
          if (thisController.state.allData.length > 0) {
            thisController.checkTreatmentStatusBatch(thisController.state.allData);
          }
          thisController.state.disabled = false;
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          thisController.filterActiveProcedures();
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva-api/login";
        }
      },
    });
  }

  fetchTreatmentsOfProvider(physicianId) {
    var thisController = this;
    if (physicianId === "00000") {
      $.ajax({
        url: "/my-jeeva-api/all-provider-treatments",
        method: "GET",
        data: {
          serviceLineId: thisController.userDetails["serviceLineId"]
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.allData = res.result;
            if (thisController.state.allData.length > 0) {
              thisController.checkTreatmentStatusBatch(thisController.state.allData);
              thisController.checkTranslationApprovalStatusBatch(thisController.state.allData);
            }
            thisController.state.disabled = false;
            thisController.state.isLoading = false;
            thisController.state.noMatchingData = false;
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            thisController.filterActiveProcedures();
            thisController.setState(thisController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/my-jeeva-api/login";
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/selected-provider-treatments",
        method: "GET",
        data: {
          providerId: physicianId,
          hospitalId: thisController.userDetails["hospitalId"],
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.allData = res.result;
            if (thisController.state.allData.length > 0) {
              thisController.checkTreatmentStatusBatch(thisController.state.allData);
              thisController.checkTranslationApprovalStatusBatch(thisController.state.allData);
            }
            thisController.state.disabled = false;
            thisController.state.isLoading = false;
            thisController.state.noMatchingData = false;
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            thisController.filterActiveProcedures();
            thisController.setState(thisController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/my-jeeva-api/login";
          }
        },
      });
    }

  }




  physicianOptionChange = (event) => {
    const thisController = this;
    const targetValue = event.target.value;
    var providerId = thisController.userDetails.userId
    thisController.setState({ searchTerm: "" });

    if (targetValue === "00000") {
      thisController.setState({
        selectedFilter: "allDepartmentTreatments",
        selectedPhysicianId: targetValue
      }
      )
    }

    if (targetValue === providerId) {
      thisController.setState({
        selectedFilter: "myTreatments",
        selectedPhysicianId: targetValue
      },
        () => {
          thisController.fetchTreatmentsOfProvider(targetValue);
        }
      )
    } else {
      thisController.setState(
        {
          selectedPhysicianId: targetValue,
        },
        () => {
          thisController.fetchTreatmentsOfProvider(targetValue);
        }
      );
    }
  };

  fetchAllPhysicians() {
    var fetchDataContoller = this;
    var lastUsedDropdown = localStorage.getItem("last-used-dropdown");
    $.ajax({
      url: "/my-jeeva-api/all-physicians-in-department",
      method: "GET",
      data: {
        hospitalId: fetchDataContoller.userDetails["hospitalId"]
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var physiansList = res.result;
          for (var j = 0; j < physiansList.length; j++) {
            if (physiansList[j].id === fetchDataContoller.userDetails["userId"]) {
              fetchDataContoller.state.allPhysicians.unshift(physiansList[j]);
            } else {
              fetchDataContoller.state.allPhysicians.push(physiansList[j]);
            }
          }
          if (res.result.length > 0) {
            if (lastUsedDropdown === "myHospital") {
              fetchDataContoller.state.allPhysicians.unshift({ id: "00000", userName: "All" });
            } else if (lastUsedDropdown === "myDepartment") {
              fetchDataContoller.state.allPhysicians.unshift({ id: "00000", userName: "All" });
            } else {
              fetchDataContoller.state.allPhysicians.push({ id: "00000", userName: "All" });
            }
          }
          fetchDataContoller.setState(fetchDataContoller.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva-api/login";
        }
      },
    });
  }

  fetchPhysicians = () => {
    var treatmentId = localStorage.getItem("selectedTreatmentId");
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    console.log(
      "The selected Treatment Id for physician is: " +
      thisController.state.selectedTreatmentId
    );

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    }

    var data = {
      role: "PHYSICIAN",
      healthSystemId: thisController.state.selectedHealthSystemId,
      hospitalId: thisController.state.selectedHospitalId,
    };

    if (treatmentId) {
      data.procedureId = treatmentId;
    }

    if (!treatmentId) {
      return;
    }
    var physicianLoadPromise = new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/physicians",

        method: "GET",
        data: {
          procedureId: treatmentId
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },

        /*  url: "/my-jeeva-api/fetch-provider",
  
                      method: 'GET',
                      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                      data: {
                          treatmentId:  thisController.state.selectedTreatmentId,
                      },*/

        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var provider = res.result;
            console.log(provider);
            var noOfProviders = provider.length;
            thisController.physicianVar = [];

            var physiciansByServiceLine = [];
            for (var i = 0; i < noOfProviders; i++) {
              thisController.physicianVar.push(provider[i]);
              if (!physiciansByServiceLine[provider[i].serviceLineId]) {
                physiciansByServiceLine[provider[i].serviceLineId] = [];
              }
              physiciansByServiceLine[provider[i].serviceLineId].push(
                provider[i]
              );
            }
            thisController.physiciansByServiceLine = physiciansByServiceLine;
            if (resolve) {
              resolve();
            }
          } else {
            if (reject) {
              reject();
            }
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (reject) {
            reject();
          }
          if (xhr.status == 401) {
            window.location.href = "/my-jeeva-api/login";
          }
        },
      });
    });

    return physicianLoadPromise;
  };

  handleChangeCheckBox = (e) => {
    this.state.enableAgent = e.target.checked;
    this.setState(this.state);
  };

  clearSearchData = () => {
    var thisController = this;
    const restoreTo = thisController.state.preSearchPage || 1;
    thisController.restoredPage = restoreTo;
    localStorage.setItem("lastActivePageNum", restoreTo);
  
    thisController.setState(prevState => ({   
      searchTerm: "",
      pageNum: restoreTo,
      preSearchPage: 1,
      tableKey: prevState.tableKey + 1,
      isLoading: true,
      data: [],
    }), () => {                              
      var lastUsedDropdown = localStorage.getItem("last-used-dropdown");
      if (thisController.userDetails.userRole === "PHYSICIAN") {
        if (lastUsedDropdown === "mine" || lastUsedDropdown === null) {
          thisController.fetchHealthSystemDetails();
        } else if (lastUsedDropdown === "myHospital") {
          thisController.fetchTreatmentsOfHospital();
        } else if (lastUsedDropdown === "myDepartment") {
          thisController.fetchTreatmentsOfDepartment();
        }
      } else {
        thisController.fetchHealthSystemDetails();
      }
    });                                      
  }

  render() {
    const { data } = this.state;
    const { modalPosition } = this.state;

    const patientFilterOptions = [
      { value: "myTreatments", label: "Only my treatments" },
      { value: "allDepartmentTreatments", label: "All treatments in my department" },
      { value: "allHospitalTreatments", label: "All treatments in my hospital" },
    ];

    const loginProvider = [
      { value: this.userDetails["userId"], label: this.userDetails["name"] }
    ]

    var procedureController = this;

    var lastUsedDropdown = localStorage.getItem("last-used-dropdown");
    if (lastUsedDropdown === "myHospital") {
      lastUsedDropdown = "allHospitalTreatments"
    } else if (lastUsedDropdown === "myDepartment") {
      lastUsedDropdown = "allDepartmentTreatments"
    } else if (lastUsedDropdown === "mine") {
      lastUsedDropdown = "myTreatments"
    }

    if (lastUsedDropdown) {
      const index = patientFilterOptions.findIndex(option => option.value === lastUsedDropdown);

      if (index !== -1) {
        const [matchedOption] = patientFilterOptions.splice(index, 1); // Remove it
        patientFilterOptions.unshift(matchedOption); // Add to beginning
      }
    }

    const columns = [

      {
        name: <b style={{ fontSize: "16px" }}>Treatment Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('name'),
        width: "19vw",
        selector: (row) => {
          const userDetails = JSON.parse(localStorage.getItem('user_details'));
          let backgroundColor = "white";
          let tooltipText = "";

          if (userDetails && userDetails.userRole === "PHYSICIAN") {
            const emailId = userDetails.emailId;
            backgroundColor = this.providerOwner(row) !== emailId ? 'lightblue' : 'white';
            tooltipText = this.providerOwner(row) !== emailId ? "Read-only treatment defined by admin" : "";
          }

          return (
            <div
              className="textarea"
              style={{
                background: backgroundColor,
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id === "" || row.id === this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id === "" ? "2px" : "none",
              }}
              onInput={(e) => {
                this.handleNameChange(e, row);
              }}
              id={"name" + row.id}
              contentEditable={
                !(row.id === "" ? false : row.id !== this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
              onFocus={(e) => this.moveCursorToEnd(e)}
              title={tooltipText}
            >
              {row.name}
            </div>
          );
        },
      },

      {
        name: <b style={{ fontSize: "16px" }}>Treatment Description</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('description'),
        // width: '20vw',
        width: this.userDetails["userRole"] === "PHYSICIAN" ? (window.innerWidth < 1580 ? "18vw" : "22vw") : "18vw",
        selector: (row) => {
          const userDetails = JSON.parse(localStorage.getItem('user_details'));
          let backgroundColor = "white";
          let tooltipText = "";
          let isReadOnly = false;

          if (userDetails && userDetails.userRole === "PHYSICIAN") {
            const emailId = userDetails.emailId;
            isReadOnly = this.providerOwner(row) !== emailId;
            backgroundColor = isReadOnly ? 'lightblue' : 'white';
            tooltipText = isReadOnly ? "Read-only treatment defined by admin" : "";
          }

          return (
            <div>
              <div
                className="textarea"
                style={{
                  background: backgroundColor,
                  height: "2.7em",
                  resize: "none",
                  paddingLeft: "2px",
                  paddingTop: "6px",
                  width: "100%",
                  border:
                    row.id == "" || row.id == this.state.editedId
                      ? "1px solid #D2D4DC"
                      : "none",
                  borderRadius: row.id == "" ? "2px" : "none",
                  overflowY: "scroll",
                }}
                onInput={(e) => {
                  this.handleDescriptionChange(e, row);
                }}
                id={"description" + row.id}
                name={"description" + row.id}
                contentEditable={
                  isReadOnly
                    ? false
                    : !(row.id == "" ? false : row.id != this.state.editedId)
                      ? "plaintext-only"
                      : false
                }
                title={tooltipText}
              >
                {row.description}
              </div>
            </div>
          );
        },
      },
      {
        name: <b style={{ fontSize: "16px" }}>Active Patients</b>,
        width: "8vw",
        width: this.userDetails["userRole"] === "PHYSICIAN" ? (window.innerWidth < 1580 ? "5vw" : "7vw") : "7vw",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('admissionCount'),
        selector: (row) => (
          <div>
            <div
              className="textarea"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
              }}
            >
              {row.admissionCount == null ? "0" : row.admissionCount}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Owner</b>,
        width: "14vw",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('admissionCount'),
        selector: (row) => (
          <div>
            <div
              className="textarea"
              style={{
                display: "flex",
                // justifyContent: "center",
                alignItems: "center",
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
            >
              {row.createdBy == null ? this.userDetails["emailId"] : row.createdBy}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Patient Onboarding</b>,
        // width: window.innerWidth < 768 ? "50vw" : "10vw",
        width: this.userDetails["userRole"] === "PHYSICIAN" ? (window.innerWidth < 768 ? "50vw" : "8vw") : "8vw",

        selector: (row) => (
          <div id="onboarding" className="onboarding-column">

            {/* Generate QR Code Button starts */}

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                display: window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN ? (row.id == "" || row.id == this.state.editedId ? "none" : "inline") : "none"
              }}
              onClick={() => {
                this.generateQRCode(row);
              }}
              disabled={this.state.discontinued}>
              <img
                className="img-responsive"
                title="Generate QR Code"
                style={{
                  backgroundColor: this.state.discontinued ? "#282a6596" : "#282a65",
                  borderRadius: "5px",
                  padding: "2px",
                  height: "2rem",
                }}
                src="assets/images/qr-code-64.png"
              />
            </button>

            {/* Generate QR Code Button Ends */}

            {/* Passphrase Button starts */}

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                display: window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN ? (row.id == "" || row.id == this.state.editedId ? "none" : "inline") : "none"
              }}
              onClick={(e) => this.addPassPhrase(row, e)}
              disabled={this.state.discontinued}>
              <img
                className="img-responsive"
                title="Passphrase"
                style={{
                  backgroundColor: this.state.discontinued ? "#282a6596" : "#282a65",
                  borderRadius: "5px",
                  padding: "2px",
                  height: "2rem",
                }}
                src="assets/images/key-64.png"
              />
            </button>

            {/* Passphrase Button Ends */}
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Actions</b>,
        width: this.userDetails["userRole"] == "PHYSICIAN" ? "20vw" : "auto",
        selector: (row) => (
          <div id="action">
            {/* <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px"
              }}
              onClick={(e) => {
                this.state.dataStartedProcessing
                  ? this.notifyDataProcessing()
                  : row.id === ""
                    ? this.saveTreatmentDetails(row, e)
                    : row.id === this.state.editedId
                      ? this.updateTreatmentDetails(row, e)
                      : this.makeCelledit(row, e);
              }}
              disabled={this.state.discontinued || (this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row))}>
              <img
                className="img-responsive"
                title={row.id === "" || row.id === this.state.editedId ? "Save" : "Edit"}
                style={{
                  marginTop: "6px",
                  backgroundColor: this.state.discontinued || (this.userDetails["userRole"] === "PHYSICIAN" &&
                    JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)) ? "#282a6596" : "#282a65",
                  borderRadius: "5px",
                  padding: "1px"
                }}
                src={row.id === "" ? this.saveImageSrc : row.id !== this.state.editedId ? this.editImageSrc : this.saveImageSrc}
              />
            </button> */}

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px"
              }}
              onClick={(e) => {
                this.state.dataStartedProcessing
                  ? this.notifyDataProcessing()
                  : row.id === ""
                    ? this.saveTreatmentDetails(row, e)
                    : row.id === this.state.editedId
                      ? this.updateTreatmentDetails(row, e)
                      : this.makeCelledit(row, e);
              }}
              disabled={this.state.discontinued || (this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row))}
            >
              <img
                className="img-responsive"
                title={
                  this.userDetails["userRole"] === "PHYSICIAN" &&
                    JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)
                    ? "Clone the treatment to edit"
                    : (row.id === "" || row.id === this.state.editedId ? "Save" : "Edit")
                }

                style={{
                  marginTop: "6px",
                  backgroundColor: this.state.discontinued || (this.userDetails["userRole"] === "PHYSICIAN" &&
                    JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row))
                    ? "#282a6596"
                    : "#282a65",
                  borderRadius: "5px",
                  padding: "1px"
                }}
                src={row.id === "" ? this.saveImageSrc : row.id !== this.state.editedId ? this.editImageSrc : this.saveImageSrc}
              />
            </button>

            {/* Library Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                display: window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN ? (row.id == "" || row.id == this.state.editedId ? "none" : "inline") : "none",
              }}
              onClick={() => {
                this.navigateToLibrary(row.name, row.id, this.providerOwner(row));
              }}
              disabled={this.state.discontinued}>
              <img
                className="img-responsive"
                title="Library"
                style={{
                  backgroundColor: this.state.highlightButtons[row.id] ? "rgb(5, 162, 47)" : (this.state.discontinued ? "#282a6596" : "#282a65"),
                  borderRadius: "5px",
                  padding: "2px",
                  height: "2rem",
                }}
                src="assets/images/book-stack-64.png"
              />
            </button>
            {/* Library Button Ends */}

{/* Risk Rule Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                padding: "0px",
                display: row.id == "" || row.id == this.state.editedId ? "none" : "inline"
              }}
              title="Risk Rule"
              onClick={(e) => {
                this.riskRulePage(row, e);
              }}
            >
              <img
                className="img-responsive"
                src={"./assets/images/risk-rule-256.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: this.state.highlightRuleButton[row.id] ? "rgb(5 162 47)" : (this.state.discontinued ? "#282a6596" : "#282a65"),
                  borderRadius: "5px",
                  padding: "1px",
                  height: "2rem"
                }}
              />
            </button>
            {/* Risk Rule Button ends */}

            {/* Mile stone Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                padding: "0px",
                marginLeft: "4px",
                display: row.id == "" || row.id == this.state.editedId ? "none" : "inline"
              }}
              title="Treatment Milestone"
              onClick={(e) => {
                this.treatmentMileStoneModal(row, e);
              }}
            >
              <img
                className="img-responsive"
                src={"./assets/images/milestone.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: this.state.highlightMileStoneButton[row.id] ? "rgb(5 162 47)" : (this.state.discontinued ? "#282a6596" : "#282a65"),
                  borderRadius: "5px",
                  padding: "1px",
                  height: "2rem"
                }}
              />
            </button>
            {/* Mile stone Button ends */}

            {/* Stand-alone Reminder Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                padding: "0px",
                marginLeft: "4px",
                display: row.id == "" || row.id == this.state.editedId ? "none" : "inline"
              }}
              title="Stand-alone notification"
              onClick={(e) => {
                this.standaloneReminderModal(row, e);
              }}
            >
              <img
                className="img-responsive"
                src={"./assets/images/alarm-clock-24.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: this.state.highlightStandaloneReminderButton[row.id] ? "rgb(5 162 47)" : (this.state.discontinued ? "#282a6596" : "#282a65"),
                  borderRadius: "5px",
                  padding: "1px",
                  height: "2rem"
                }}
              />
            </button>
            {/* Stand-alone Reminder Button ends */}

            {/* Agent Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                display: row.id == "" || row.id == this.state.editedId ? "none" : "inline"
              }}
              onClick={() => { this.showAgentModal(row.id, row.name, this.providerOwner(row), row.virtualAgentId) }}
              disabled={this.state.discontinued}>
              <img
                className="img-responsive"
                title="Agent"
                style={{
                  // backgroundColor: this.state.discontinued ? "#282a6596" : "#282a65",
                  backgroundColor: this.state.highlightAgentButton[row.id] ? "rgb(5 162 47)" : (this.state.discontinued ? "#282a6596" : "#282a65"),
                  borderRadius: "5px",
                  padding: "2px",
                  height: "2rem",
                }}
                src="assets/images/user-7-64.png"
              />
            </button>
            {/* Agent Button ends */}

            {/* Clone Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                display: window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN ? (row.id == "" || row.id == this.state.editedId ? "none" : "inline") : "none"
              }}
              onClick={(e) => {
                !row.id == ""
                  ? this.openClonePopUp(row)
                  : this.makeCelledit(row, e);
              }}
              disabled={this.state.discontinued}>
              <img
                className="img-responsive"
                title="Clone"
                style={{
                  backgroundColor: this.state.discontinued ? "#282a6596" : "#282a65",
                  borderRadius: "5px",
                  padding: "2px",
                  height: "2rem",
                }}
                src="assets/images/copy-64.png"
              />
            </button>

            {/* Clone Button Ends */}

{/* Enable Translation Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px",
                display: row.id == "" || row.id == this.state.editedId ? "none" : "inline",
                cursor: this.state.discontinued ? "not-allowed" : "pointer"
              }}
              onClick={() => {
                localStorage.setItem("procedureId", row.id);
                localStorage.setItem("procedureName", row.name);
                this.props.history.push('/projectmgmt/translations', {
                  procedureId: row.id,
                  procedureName: row.name
                });
              }}
              onMouseEnter={(e) => {
                if (!this.state.discontinued) {
                  e.currentTarget.style.opacity = "0.8";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "1";
              }}
              disabled={this.state.discontinued}
              title={this.state.configuredLanguages[row.id] ? "Translation Configured" : "Configure Languages"}
            >
              <img
                className="img-responsive"
                style={{
                  marginTop: "6px",
                  backgroundColor: this.getTranslationButtonColor(row.id),
                  borderRadius: "5px",
                  padding: "1px"
                }}
                src="assets/images/translate_white_24dp.svg"
              />
            </button>
            {/* Enable Translation Button Ends */}

            {/* {this.state.discontinued ? (
              <button
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  display: row.id === "" || row.id === this.state.editedId ? "none" : "inline"
                }}
                onClick={(e) => {
                  this.openContinueOrDiscontinuePopUp(row, e);
                }}
                disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)}
              >
                <img
                  className="img-responsive"
                  title="Reactivate"
                  style={{
                    backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                      JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)) ? "#282a6596" : "#282a65",
                    borderRadius: "5px",
                    padding: "4px",
                    height: "2rem",
                  }}
                  src="assets/images/ok-64.png"
                />
              </button>
            ) : (
              <button
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  display: row.id === "" || row.id === this.state.editedId ? "none" : "inline"
                }}
                onClick={(e) => {
                  this.openContinueOrDiscontinuePopUp(row, e);
                }}
                disabled={this.state.discontinued || (this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row))}>
                <img
                  className="img-responsive"
                  title="Deactivate"
                  style={{
                    backgroundColor: this.state.discontinued || (this.userDetails["userRole"] === "PHYSICIAN" &&
                      JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)) ? "#282a6596" : "#282a65",
                    borderRadius: "5px",
                    padding: "4px",
                    height: "2rem",
                  }}
                  src="assets/images/cancel-64.png"
                />
              </button>
            )} */}

            {/* Reactivate Button */}
            {this.state.discontinued ? (
              <button
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  display: row.id === "" || row.id === this.state.editedId ? "none" : "inline"
                }}
                onClick={(e) => {
                  this.openContinueOrDiscontinuePopUp(row, e);
                }}
                disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)}
              >
                <img
                  className="img-responsive"
                  title="Reactivate"
                  style={{
                    backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                      JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)) ? "#282a6596" : "#282a65",
                    borderRadius: "5px",
                    padding: "4px",
                    height: "2rem",
                  }}
                  src="assets/images/ok-64.png"
                />
              </button>
            ) : (
              <button
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  display: row.id === "" || row.id === this.state.editedId ? "none" : "inline"
                }}
                onClick={(e) => {
                  this.openContinueOrDiscontinuePopUp(row, e);
                }}
                disabled={this.state.discontinued || (this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row))}
              >
                <img
                  className="img-responsive"
                  title={
                    this.userDetails["userRole"] === "PHYSICIAN" &&
                      JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)
                      ? "Clone the treatment to edit"
                      : "Deactivate"
                  }
                  style={{
                    backgroundColor: this.state.discontinued || (this.userDetails["userRole"] === "PHYSICIAN" &&
                      JSON.parse(localStorage.getItem('user_details')).emailId !== this.providerOwner(row)) ? "#282a6596" : "#282a65",
                    borderRadius: "5px",
                    padding: "4px",
                    height: "2rem",
                  }}
                  src="assets/images/cancel-64.png"
                />
              </button>
            )}

          </div>
        ),
      },
    ];

    return (
      <div style={{ marginRight: "1%" }} id="procedureTab">
        {this.state.translationFor && (
          <TranslationPanel
            entityType={this.state.translationFor.entityType}
            entityId={this.state.translationFor.entityId}
            title={this.state.translationFor.title}
            fields={this.state.translationFor.fields}
            onClose={() => this.setState({ translationFor: null })}
          />
        )}
        <div
          style={{
            background: "#F9F9FB",
            display: "block",
          }}
        >
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          <link rel="stylesheet" href="assets/css/buttonForm.css" />

          <div className="row" style={{ marginLeft: "1vh" }}>
            <div className="col-sm-4" style={{ marginTop: "2px" }}></div>
          </div>

          <div className="row procedure-col" style={{ marginLeft: "14px", marginBottom: "1.5rem" }}>
            <div className="col-sm-1">
              <h6
                className="nav-item"
                style={{ color: "#282a65", marginTop: "1vh" }}
              >
                Treatments
              </h6>
            </div>
            <div
              className="col-sm-8 procedure-tabs"
              Align="right"
              style={{ marginLeft: "-8.5vw", paddingTop: "2.2rem" }}
            >
              <label
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                      ? "inline"
                      : "none",
                  marginLeft: "-4rem",
                }}
              >
                Health System
              </label>

              <select
                value={this.state.selectedHealthSystemId}
                id="healthSystem"
                className="healthSystem"
                onChange={(e) => this.onHealthSystemChange(e)}
                placeholder="Select Health System"
                ref={this.healthSystemDropDownInProcedureRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                      ? "inline"
                      : "none",

                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.healthSystemGroupValue.map((healthSystem) => (
                  <option value={healthSystem.value}>
                    {healthSystem.name}
                  </option>
                ))}
              </select>
              <label
                style={{
                  marginLeft: "3vh",
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Hospital
              </label>

              <select
                value={this.state.selectedHospitalId}
                id="hospitalDropDown"
                className="hospital"
                onChange={(e) => this.onHospitalChange(e)}
                placeholder="Select hospital"
                ref={this.hospitalDropDownInProcedureRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.hospitalGroupValue.map((hospitalGroup) => (
                  <option value={hospitalGroup.value}>
                    {hospitalGroup.name}
                  </option>
                ))}
              </select>

              <label
                style={{
                  marginLeft: "3vh",
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Service Line
              </label>
              <select
                value={this.state.selectedServiceLineId}
                id="serviceLine"
                className="hospital"
                onChange={(e) => this.onServiceLineChange(e)}
                placeholder="Select serviceline"
                ref={this.serviceLineDropDownInProcedureRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.serviceLineGroupValue.map((serviceLineGroup) => (
                  <option value={serviceLineGroup.value}>
                    {serviceLineGroup.name}
                  </option>
                ))}
              </select>
              <label
                style={{
                  marginLeft: "-70vh",
                  display:
                    window.SCOPE_VALUE.CURRENT <
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                View Options
              </label>


              <select
                value={this.state.selectedFilter}
                id="serviceLine"
                className="hospital"
                onChange={(e) => this.filterOptionChange(e)}
                placeholder="Select option"
                // ref={this.seriviceLineDropDownInMARef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT <
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {patientFilterOptions.map((filters) =>
                  <option value={filters.value}>
                    {filters.label}
                  </option>
                )}

              </select>
              <label
                style={{
                  marginLeft: "3vh",
                  display:
                    window.SCOPE_VALUE.CURRENT <
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Providers
              </label>
              {lastUsedDropdown === null || lastUsedDropdown === "myTreatments" ||
                //  this.state.selectedFilter === "" || 
                this.state.selectedFilter === "myTreatments"
                ?
                <select
                  id="physicianId"
                  className="hospital"
                  value={this.state.selectedPhysicianId}
                  onChange={(e) => this.physicianOptionChange(e)}
                  placeholder="Select option"
                  style={{
                    display:
                      window.SCOPE_VALUE.CURRENT <
                        window.SCOPE_VALUE.SERVICELINE_ADMIN
                        ? "inline"
                        : "none",
                    height: "30px",
                    borderRadius: "4px",
                    backgroundColor: "#F9F9FB",
                    width: "13vw",
                    marginLeft: "10px",
                  }}
                >
                  {
                    loginProvider.map((provider) =>
                      <option key={provider.value} value={provider.value}>
                        {provider.label}
                      </option>
                    )
                  }

                </select>

                :
                <select
                  id="physicianId"
                  className="hospital"
                  value={this.state.selectedPhysicianId}
                  onChange={(e) => this.physicianOptionChange(e)}
                  placeholder="Select option"
                  style={{
                    display:
                      window.SCOPE_VALUE.CURRENT <
                        window.SCOPE_VALUE.SERVICELINE_ADMIN
                        ? "inline"
                        : "none",
                    height: "30px",
                    borderRadius: "4px",
                    backgroundColor: "#F9F9FB",
                    width: "13vw",
                    marginLeft: "10px",
                  }}
                >
                  {
                    this.state.allPhysicians.map((physician) => {
                      return (
                        (this.state.selectedFilter === "allHospitalTreatments" ||
                          lastUsedDropdown === "allHospitalTreatments") ? (
                          <option key={physician.id} value={physician.id}>
                            {physician.userName}
                          </option>
                        ) : (
                          (this.userDetails["serviceLineId"] === physician.serviceLineId || physician.id === "00000") && (
                            <option key={physician.id} value={physician.id}>
                              {physician.userName}
                            </option>
                          )
                        )
                      );
                    })
                  }

                </select>
              }
            </div>

            <div
              style={{ marginLeft: "1.5vw", marginTop: "3.35vh" }}>
              <input
                type="text"
                style={{
                  width: "10vw",
                  border: "1px solid #777676",
                  borderRadius: "3px",
                  padding: "10px",
                  height: "0.6vw",
                  paddingRight: "2rem",
                }}
                value={this.state.searchTerm}
                onChange={this.handleSearch}
                placeholder="Search ..."
              />
              {this.state.searchTerm && (
                <span
                  onClick={() => this.clearSearchData()}
                  style={{
                    // position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#777676",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    lineHeight: 1,
                    userSelect: "none",
                    marginLeft: "-1vw"
                  }}
                >
                  ×
                </span>
              )}
            </div>
            <div className="col-sm-2 " style={{ marginTop: "3px" }}>
              <div className="d-flex flex-row-reverse pt-2">
                <div
                  className="p-2"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <button
                    className="btn action-button"
                    id="addMsg"
                    title=" Add "
                    onClick={
                      this.state.disabled
                        ? this.notifyEmptyField
                        : this.addNewProcedure
                    }
                    disabled={this.state.discontinued}
                    style={{
                      display:
                        window.SCOPE_VALUE.CURRENT >
                          window.SCOPE_VALUE.PHYSICIAN
                          ? "inline"
                          : "none",
                    }}
                  >
                    <img src="assets/images/add_white_24dp.png" />
                  </button>
                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>
                  <label className="switch" style={{ display: "flex", color: "black", fontWeight: "bold" }}>
                    <input
                      type="checkbox"
                      id="Discontinued"
                      checked={this.state.discontinued}
                      style={{
                        width: "22px",
                        height: "22px",
                        marginRight: "3rem",
                      }}
                      onChange={(e) => {
                        this.handleCheckBoxChange(e);
                      }}
                    />{" "}
                    Inactive
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal"
            style={{
              display: this.state.showQrCode ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="modal-dialog"
              id="center-aligned-account-modal"
              style={{
                marginTop: "-12rem",
                marginLeft: "15rem",
              }}
            >
              <div
                className="modal-content"
                style={{
                  height: "auto",
                  marginTop: "10vw",
                  width: "33vw",
                  marginLeft: "19vw",
                  position: "relative",
                  top: modalPosition.y + "px",
                  left: modalPosition.x + "px",
                  cursor: this.state.isDragging ? 'grabbing' : 'grab'

                }}
                onMouseDown={this.handleMouseDown}
                Align="center"
              >
                <div className="modal-header noBorder">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.closeQrCodePage();
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    style={{
                      cursor: "pointer",
                      position: "relative",
                      zIndex: 9999,
                      padding: "10px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
                <div className="modal-body">
                  <h5 Align="center">{localStorage.getItem("procedureName")} Treatment QR Code</h5>
                  <form ref={(el) => (this.myFormRef = el)}>
                    <img
                      id="qr_code"
                      src={this.state.qrCode}
                      style={{
                        width: "21vw",
                        marginLeft: "-1vw",
                        height: "21vw",
                      }}
                    />
                  </form>
                  <p>
                    <b>Note: </b>Please open your MyJEEVA app and scan the
                    Treatment QR Code
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal"
            style={{
              display: this.state.showPassPhrase ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <div
              className="modal-dialog"
              id="center-aligned-account-modal"
              style={{ marginTop: "-12rem", marginLeft: "15rem" }}>
              <div
                className="modal-content"
                style={{
                  height: "auto",
                  marginTop: "10vw",
                  width: "33vw",
                  marginLeft: "19vw",
                }}
                Align="center"
              >
                <div className="modal-header noBorder">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={(e) => { this.setState({ showPassPhrase: false, passPhrase: "" }); localStorage.removeItem("procedureName"); e.stopPropagation() }}
                    onMouseDown={(e) => e.stopPropagation()}
                    style={{
                      cursor: "pointer",
                      position: "relative",
                      zIndex: 9999,
                      padding: "10px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>


                </div>
                <div className="modal-body">
                  <h5 Align="center">{localStorage.getItem("procedureName")} Treatment Pass Phrase</h5>

                  <input style={{ marginTop: "1vh" }} type="text" placeholder="Enter the Pass Phrase" value={this.state.passPhrase} onChange={(e) => { this.handlePassPhraseChange(e) }} />
                  <button type="button" className="btn action-button"
                    onClick={this.savePassPhrase} >Save</button>
                  <button type="button" className="btn action-button"
                    onClick={this.deletePassPhrase} >Delete</button>
                  <p>
                    <b>Note: </b>Please provide this Passphrase to patients only if they are unable to login using QR Code.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal"
            style={{
              display: this.state.showAgent ? "block" : "none",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <div
              className="modal-dialog"
              id="center-aligned-account-modal"
              style={{ marginTop: "-12rem", marginLeft: "15rem" }}>
              <div
                className="modal-content"
                style={{
                  height: "auto",
                  marginTop: "10vw",
                  width: "33vw",
                  marginLeft: "19vw",
                }}
                Align="center"
              >
                <div className="modal-header noBorder">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={() => this.setState({ showAgent: false, selectedAgent: "", agentMap: {} })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
                <div className="modal-body">
                  {/* <p style={{wordWrap:"break-word"}} >{this.getSlectedAgent()}</p> */}
                  <h4 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>Agent and Avatar for Treatment</h4>
                  <label style={{ color: "black", fontWeight: "bold" }}>
                    <input
                      type="checkbox"
                      checked={this.state.enableAgent}
                      onChange={this.handleChangeCheckBox}
                      style={{ marginRight: "10px" }}
                    />
                    Enable AI agent in patient application
                  </label>
                  <br />
                  {/* <h3>Choose Agent</h3> */}
                  <label>Choose Agent</label>
                  <select
                    id="agentSelectionBox"
                    disabled={!this.state.enableAgent}
                    value={this.state.treatmentAgentId || ""}
                    // onChange={(e) => {
                    //   procedureController.selectedAgentId = e.target.value;
                    //   procedureController.selectedAgentName = e.target.options[e.target.selectedIndex].text
                    // }}
                    onChange={(e) => {
                      this.setState({ treatmentAgentName: e.target.value });
                      procedureController.selectedAgentId = e.target.value;
                      procedureController.selectedAgentName =
                        e.target.options[e.target.selectedIndex].text;
                    }}
                  >

                    {/* <option>Choose Agent</option>
                    {this.state.agents.map((agent) => {
                      return (
                        <option value={`${agent.id}`} selected={agent.id === procedureController.state.treatmentAgentId}>{agent.name}</option>
                      )
                    })} */}
                    <option value="">Choose Agent</option>
                    {Object.values(this.agentMap || {}).map((agent) => (
                      <option key={agent.id} value={agent.id}>
                        {agent.name}
                      </option>))}
                  </select>
                  <br />
                  <br />
                  <label>Choose Avatar</label>
                  <select
                    id="avatarSelectionBox"
                    disabled={!this.state.enableAgent}
                    value={this.state.treatmentAvatarName}
                    // onChange={(e) => {
                    //   procedureController.selectedAvatar = e.target.value
                    // }}
                    onChange={(e) => {
                      this.setState({ treatmentAvatarName: e.target.value }); // update state
                      procedureController.selectedAvatar = e.target.value;   // also update controller
                    }}
                  >
                    <option value="">Choose Avatar</option>
                    {this.state.avatars.map((avatar) => (
                      <option key={avatar.name} value={avatar.name}>
                        {avatar.name}
                      </option>
                    ))}
                  </select>
                  <br />
                  <br />
                  <button
                    type="button"
                    className="btn btn-primary pull-right navyblue-btn"
                    style={{ width: "auto", fontSize: "14px" }}
                    onClick={this.saveAgent}
                    disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                      JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
          {this.state.showStandaloneReminders && this.renderStandaloneReminderModal()}
          {this.state.showReminderTranslationModal && this.renderReminderTranslationModal()}
          <div
            className="modal"
            style={{
              display: this.state.showTreatmentMileStones ? "block" : "none",
            }}
          >
            <div className="modal-dialog" id="center-aligned-account-modal">
              <div
                className="modal-content"
                style={{ height: "600px", width: "900px" }}
              >
                <div className="modal-header noBorder">
                  <div className="row">
                    <div className="col-sm-12" align="center"></div>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={this.handleCloseMilestoneModal}
                    style={{ marginRight: "1vw" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
                <div className="modal-body" style={{ overflowY: 'scroll' }}>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  </div>
                  <form>
                    <div className="row">
                      <div className="col-sm-10" style={{ marginRight: "0px" }}>
                        <h4
                          className="nav-item"
                          style={{
                            color: "#282a65",
                            marginTop: "20px",
                            textAlign: "center",
                          }}
                        >
                          Define Milestone of {this.state.selectedTreatmentForMilestone} Treatment
                        </h4>
                        <h6
                          className="nav-item"
                          style={{
                            color: "#282a65",
                            marginTop: "20px",
                            textAlign: "center",
                          }}
                        >Select treatment milestones and create custom milestones</h6>
                        <div
                          style={{
                            marginTop: "3.5em",
                            overflowY: "scroll",
                            maxHeight: "44vh",
                            display: this.state.showCreatbleSelect ? "none" : "block"
                          }}
                          align="center"
                          id="appearance-for-selected-languages"
                        >
                          {this.state.selectedMileStoneNames.map(
                            (selectedMileStone) => (
                              <span>
                                <button disabled={true} className="bubble">
                                  {selectedMileStone.mileStoneName}
                                </button>
                                <br />
                              </span>
                            )
                          )}
                        </div>
                        <div
                          style={{ display: this.state.showCreatbleSelect ? "block" : "none" }}
                        >


                          <CreatableSelect
                            isClearable
                            isMulti
                            options={this.state.predefinedMileStones}
                            inputValue={this.state.inputValue}
                            onInputChange={this.handleInputChange}
                            onChange={this.handleChange}
                            value={this.state.selectedOptions}
                            placeholder="To add, select a milestone below or type a custom milestone"
                          />
                        </div>
                        <div
                          style={{
                            display:
                              this.state.editSelectedTreatmnt == true
                                ? "block"
                                : "none",
                            margin: "5em 3em",
                          }}
                        >

                        </div>
                        <div
                          className="col-sm-10"
                          align="center"
                        >

                        </div>
                        <button
                          type="button"
                          className="btn btn-primary pull-right navyblue-btn"
                          style={{
                            width: "auto", fontSize: "14px",
                            display: this.state.showCreatbleSelect ? "block" : "none",
                            backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                              JSON.parse(localStorage.getItem('user_details')).emailId !== this.state.selectedTreatmentCreatedBy) ? "#282a6596" : "#282a65"
                          }}
                          onClick={this.saveMileStones}
                          disabled={(this.userDetails["userRole"] === "PHYSICIAN" &&
                            JSON.parse(localStorage.getItem('user_details')).emailId !== this.state.selectedTreatmentCreatedBy)
                          }
                        >
                          Save Changes
                        </button>
                      </div>
                      <button
                        className="btn action-button"
                        style={{ marginTop: "40px", display: this.state.showCreatbleSelect ? "none" : "block" }}
                        title="Add or Remove Milestones"
                        disabled={(this.userDetails["userRole"] === "PHYSICIAN" &&
                          JSON.parse(localStorage.getItem('user_details')).emailId !== this.state.selectedTreatmentCreatedBy)
                        }
                        onClick={this.enableCreatbleSelect}
                      >
                        <img
                          className="img-responsive cursor-change"
                          src="./assets/images/editWithWhiteFilled.png"
                        />
                      </button>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div
            className="row"
            style={{ marginLeft: "15px", marginTop: "-15px" }}
          >
            <div className="col-lg-12 ">
              {this.state.noTreatments && (
                <div className="card">
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "17px",
                      paddingTop: "12px",
                    }}
                  >
                    There are no treatments currently mapped to your account,
                    Please request your Service Line Admin or Hospital Admin to
                    configure your treatments.
                  </p>
                </div>
              )}
              {!this.state.noTreatments && !this.state.noMatchingData && (
                <div className="card">
                  {this.state.isLoading && (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                      <p>Loading ...</p>
                    </div>
                  )}
                  {!this.state.isLoading && this.state.data.length === 0 && (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                      <p>There are no procedures present.</p>
                    </div>
                  )}
                  {(!this.state.isLoading && this.state.data.length > 0) && (

                    <DataTable
                      key={"table-" + this.state.pageNum}
                      data={data}
                      columns={columns}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}
                      pagination={this.state.paginationValue}
                      onChangePage={this.onPageChange}
                      // page={this.state.pageNum}
                      paginationDefaultPage={this.state.pageNum || 1}
                      noDataComponent={<this.CustomNoDataComponent />}
                    />)}
                </div>
              )}
              <ToastContainer className="Toast-at-center" />
            </div>
          </div>
          <div className='card'>
            {this.state.noMatchingData &&
              <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                <p>No matching options found ...</p>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  /* ------------------------------------------------------------------ *
   *  Stand-alone reminder window                                        *
   * ------------------------------------------------------------------ */
  renderStandaloneReminderModal() {
    const overlayStyle = {
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0, 0, 0, 0.5)", display: "flex",
      alignItems: "center", justifyContent: "center", zIndex: 100000,
    };
    const modalStyle = {
      background: "#fff", borderRadius: "12px", width: "min(1560px, 97vw)",
      maxHeight: "90vh",
      // overflow sits on the body below, not here, so the header and the + button stay put
      // while a long list of reminders scrolls underneath them.
      overflow: "hidden",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
      display: "flex", flexDirection: "column",
    };
    const bodyStyle = {
      padding: "16px 22px",
      overflowY: "auto",
      // The table has nine columns, so allow sideways scrolling rather than crushing the
      // inputs on a narrow screen.
      overflowX: "auto",
      flex: "1 1 auto",
      minHeight: 0,
    };
    const headerStyle = {
      padding: "16px 22px", borderBottom: "2px solid #f0f0f0",
      display: "flex", justifyContent: "space-between", alignItems: "center",
      background: "#282a65", borderRadius: "12px 12px 0 0",
      flex: "0 0 auto",
    };
    const cellInput = {
      width: "95%", border: "1px solid #D2D4DC",
      borderRadius: "4px", fontSize: "10pt", padding: "2px 4px",
    };
    // A field the chosen offset type does not use: greyed out so it reads as not editable.
    const disabledCellInput = {
      ...cellInput, backgroundColor: "#e9ecef", color: "#9aa0a6", cursor: "not-allowed",
    };
    const iconStyle = { backgroundColor: "#282a65", borderRadius: "5px", padding: "1px" };
    const readOnly = this.isStandaloneReminderReadOnly();
    const lockedIconStyle = { ...iconStyle, backgroundColor: "#282a6596", cursor: "not-allowed" };

    return (
      <div style={overlayStyle} onClick={this.closeStandaloneReminderModal}>
        <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
          <div style={headerStyle}>
            <div>
              <h4 style={{ color: "#fff", margin: 0, fontSize: "18px", fontWeight: 700 }}>
                Stand-alone reminders
              </h4>
              <small style={{ color: "#d7d8ea" }}>
                {this.state.standaloneReminderTreatmentName}
              </small>
            </div>
            <div>
              <button className="btn action-button"
                title={readOnly ? "Read-only treatment defined by admin" : " Add "}
                style={{ marginRight: "8px", backgroundColor: readOnly ? "#282a6596" : undefined }}
                disabled={readOnly}
                onClick={readOnly ? undefined : (this.state.disableAddReminderButton
                  ? this.notifyReminderFieldEmpty : this.addEmptyReminderRow)}>
                <img src="assets/images/add_white_24dp.png" alt="Add" />
              </button>
              <img src="./assets/images/clear.svg" alt="Close" title="Close"
                style={{ cursor: "pointer", height: "22px", filter: "brightness(0) invert(1)" }}
                onClick={this.closeStandaloneReminderModal} />
            </div>
          </div>

          <div style={bodyStyle}>
            {readOnly && (
              <div style={{
                fontSize: "10pt", color: "#7a5b00", background: "#fff8e1",
                border: "1px solid #f3d27a", borderRadius: "4px",
                padding: "8px 12px", marginBottom: "12px",
              }}>
                View only: this treatment was defined by an admin, so its stand-alone reminders
                can be viewed but not added, edited or deleted.
              </div>
            )}
            {/* The disabled field has a tooltip, but a tooltip is only found by accident. */}
            <div style={{
              fontSize: "10pt",
              color: "#444",
              background: "#f4f5fb",
              border: "1px solid #d7d8ea",
              borderRadius: "4px",
              padding: "8px 12px",
              marginBottom: "12px",
            }}>
              This page allows you to create and modify stand-alone patient notifications for the
              selected treatment. Notifications are sent to patients based on a milestone and
              optional day/time offset.
              <br />
              <b>Floating time</b> defines notifications relative to the patient-specific milestone.
              Day, hour, and minute offsets enable the notification to be sent a specific time
              before (negative offset) or after (positive offset) the patient milestone.
              <br />
              <b>Specific time</b> defines notifications at a specific time of the day (in 24-hour
              format). The Day offset enables the message to be sent before or after the day of
              the patient milestone.
              <br />
              The <b>Notification title</b> and <b>Notification message</b> are displayed to the
              patient in their smartphone notification window.
            </div>

            {this.state.reminderMilestonesLoaded && this.state.reminderMilestones.length === 0 && (
              <div style={{ padding: "10px", textAlign: "center", color: "#a33" }}>
                <p>This treatment has no milestones yet. Add one before setting reminders.</p>
              </div>
            )}

            {this.state.milestoneReminders.length === 0 && this.state.reminderMilestones.length > 0 && (
              <div style={{ padding: "20px", textAlign: "center" }}>
                <p>No stand-alone reminder set for this treatment.</p>
              </div>
            )}

            {this.state.milestoneReminders.length > 0 && (
              <table className="table" style={{ fontSize: "10pt" }}>
                <thead>
                  <tr>
                    <th><b>Milestone</b></th>
                    <th style={{ width: "150px" }}><b>Offset type</b></th>
                    <th style={{ width: "90px" }}><b>Days offset</b></th>
                    <th style={{ width: "120px" }}><b>Hours offset</b></th>
                    <th style={{ width: "120px" }}><b>Minutes offset</b></th>
                    <th style={{ width: "110px" }}><b>Time</b></th>
                    <th><b>Notification title</b></th>
                    <th><b>Notification message</b></th>
                    <th style={{ width: "150px" }}><b>Action</b></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.milestoneReminders.map((row) => {
                    const isEditing = row.id === this.state.editedReminderId;
                    const isDayTime = isEditing
                      ? this.state.reminderOffsetType === "FLOATING_TIME"
                      : row.offsetType === "FLOATING_TIME";
                    return (
                      <tr key={row.id || "new-reminder"}>
                        <td>
                          {isEditing ? (
                            <select style={cellInput}
                              value={this.state.reminderMilestoneId}
                              onChange={(e) => this.handleReminderFieldChange("reminderMilestoneId", e)}>
                              <option value="">Select milestone</option>
                              {this.state.reminderMilestones.map((milestone) => (
                                <option key={milestone.id} value={milestone.id}>
                                  {milestone.mileStoneName}
                                </option>
                              ))}
                            </select>
                          ) : row.milestoneName}
                        </td>
                        <td>
                          {isEditing ? (
                            <select style={cellInput}
                              value={this.state.reminderOffsetType}
                              onChange={(e) => this.handleReminderFieldChange("reminderOffsetType", e)}>
                              <option value="SPECIFIC_TIME">Specific time</option>
                              <option value="FLOATING_TIME">Floating time</option>
                            </select>
                          ) : (row.offsetType === "FLOATING_TIME" ? "Floating time" : "Specific time")}
                        </td>
                        <td>
                          {isEditing ? (
                            <input type="number" style={cellInput}
                              value={this.state.reminderDayOffset}
                              onChange={(e) => this.handleReminderFieldChange("reminderDayOffset", e)} />
                          ) : row.dayOffset}
                        </td>
                        <td>
                          {isEditing ? (
                            <input type="number" style={isDayTime ? cellInput : disabledCellInput}
                              disabled={!isDayTime}
                              title={isDayTime ? "" : "Only used by a floating time reminder"}
                              value={this.state.reminderHourOffset}
                              onChange={(e) => this.handleReminderFieldChange("reminderHourOffset", e)} />
                          ) : (row.hourOffset == null ? "-" : row.hourOffset)}
                        </td>
                        <td>
                          {isEditing ? (
                            <input type="number" style={isDayTime ? cellInput : disabledCellInput}
                              min={-59} max={59}
                              disabled={!isDayTime}
                              title={isDayTime ? "-59 to 59" : "Only used by a floating time reminder"}
                              value={this.state.reminderMinuteOffset}
                              onChange={(e) => this.handleReminderFieldChange("reminderMinuteOffset", e)} />
                          ) : (row.offsetType === "FLOATING_TIME" ? (row.minuteOffset || 0) : "-")}
                        </td>
                        <td>
                          {isEditing ? (
                            <input type="time" style={isDayTime ? disabledCellInput : cellInput}
                              disabled={isDayTime}
                              title={isDayTime ? "A floating time reminder uses the milestone's own time" : ""}
                              value={this.state.reminderTimeOfDay}
                              onChange={(e) => this.handleReminderFieldChange("reminderTimeOfDay", e)} />
                          ) : (row.timeOfDay || "-")}
                        </td>
                        <td>
                          {isEditing ? (
                            <input type="text" style={cellInput} placeholder="Notification title"
                              value={this.state.reminderTitle}
                              onChange={(e) => this.handleReminderFieldChange("reminderTitle", e)} />
                          ) : row.title}
                        </td>
                        <td>
                          {isEditing ? (
                            <input type="text" style={cellInput} placeholder="Notification message"
                              value={this.state.reminderContent}
                              onChange={(e) => this.handleReminderFieldChange("reminderContent", e)} />
                          ) : row.content}
                        </td>
                        <td>
                          <button style={{ backgroundColor: "#ffffff", border: "none" }}
                            disabled={readOnly}
                            title={readOnly ? "Read-only treatment defined by admin" : (isEditing ? "Save" : "Edit")}>
                            <img className="img-responsive" style={readOnly ? lockedIconStyle : iconStyle}
                              src={isEditing
                                ? "./assets/images/baseline_save_white_24dp.png"
                                : "./assets/images/edit2.png"}
                              onClick={() => {
                                if (readOnly) {
                                  return;
                                }
                                if (!isEditing) {
                                  this.markReminderAsBeingEdited(row);
                                } else if (row.id === "") {
                                  this.saveMilestoneReminder();
                                } else {
                                  this.updateMilestoneReminder(row);
                                }
                              }} />
                          </button>
                          <button style={{
                            backgroundColor: "#ffffff", border: "none",
                            display: row.id === "" ? "none" : "inline",
                          }} title="Translate">
                            <img className="img-responsive" style={iconStyle}
                              src={"./assets/images/translate_white_24dp.svg"}
                              onClick={() => this.openReminderTranslationModal(row)} />
                          </button>
                          <button style={{ backgroundColor: "#ffffff", border: "none" }}
                            disabled={readOnly}
                            title={readOnly ? "Read-only treatment defined by admin" : "Delete"}>
                            <img className="img-responsive" style={readOnly ? lockedIconStyle : iconStyle}
                              src={"./assets/images/baseline_delete_white_24dp.png"}
                              onClick={() => readOnly ? undefined : row.id === ""
                                ? this.fetchMilestoneReminders(this.state.standaloneReminderTreatmentId)
                                : this.openDeleteReminderPopUp(row)} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}

            {this.state.editedReminderId !== "-1" && this.reminderOffsetPreview() && (
              <div style={{
                fontSize: "10pt", paddingTop: "4px",
                color: this.reminderMinutesError() ? "#c62828" : "#282a65",
              }}>
                {this.reminderOffsetPreview()}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  /* ------------------------------------------------------------------ *
   *  Reminder translation modal                                         *
   * ------------------------------------------------------------------ */
  renderReminderTranslationModal() {
    const row = this.state.selectedReminderForTranslation;
    if (!row) return null;

    const overlayStyle = {
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0, 0, 0, 0.5)", display: "flex",
      alignItems: "center", justifyContent: "center", zIndex: 100001,
    };
    const modalStyle = {
      background: "#fff", borderRadius: "12px", width: "min(640px, 70vw)",
      maxHeight: "80vh", overflowY: "auto",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
      display: "flex", flexDirection: "column",
    };
    const headerStyle = {
      padding: "16px 22px", borderBottom: "2px solid #f0f0f0",
      display: "flex", justifyContent: "space-between", alignItems: "center",
      background: "#282a65", borderRadius: "12px 12px 0 0",
    };
    const fieldStyle = {
      width: "100%", border: "1px solid #D2D4DC",
      borderRadius: "4px", fontSize: "10pt", padding: "6px 8px",
    };
    const labelStyle = { fontWeight: 600, fontSize: "10pt", marginBottom: "4px" };

    return (
      <div style={overlayStyle} onClick={this.closeReminderTranslationModal}>
        <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
          <div style={headerStyle}>
            <h4 style={{ color: "#fff", margin: 0, fontSize: "18px", fontWeight: 700 }}>
              Translate reminder
            </h4>
            <img src="./assets/images/clear.svg" alt="Close" title="Close"
              style={{ cursor: "pointer", height: "22px", filter: "brightness(0) invert(1)" }}
              onClick={this.closeReminderTranslationModal} />
          </div>

          <div style={{ padding: "16px 22px" }}>
            <div style={{ marginBottom: "14px" }}>
              <div style={labelStyle}>Language</div>
              <select style={fieldStyle}
                value={this.state.selectedReminderLanguage}
                onChange={this.handleReminderLanguageChange}>
                {this.state.reminderTranslationLanguages.map((language) => (
                  <option key={language.code} value={language.code}>
                    {language.displayName}
                  </option>
                ))}
              </select>
            </div>

            {this.state.reminderAutoTranslating && (
              <div style={{ padding: "8px 0", fontSize: "10pt", color: "#666" }}>
                Auto-translating ...
              </div>
            )}

            <div style={{ marginBottom: "14px" }}>
              <div style={labelStyle}>Title</div>
              <div style={{ fontSize: "9pt", color: "#888", marginBottom: "4px" }}>{row.title}</div>
              <input type="text" style={fieldStyle}
                dir={textDirection(this.state.selectedReminderLanguage)}
                value={this.state.reminderTranslationFields.title}
                onChange={(e) => this.handleReminderTranslationFieldChange("title", e.target.value)} />
            </div>

            <div style={{ marginBottom: "18px" }}>
              <div style={labelStyle}>Message</div>
              <div style={{ fontSize: "9pt", color: "#888", marginBottom: "4px" }}>{row.content}</div>
              <textarea rows="4" style={fieldStyle}
                dir={textDirection(this.state.selectedReminderLanguage)}
                value={this.state.reminderTranslationFields.content}
                onChange={(e) => this.handleReminderTranslationFieldChange("content", e.target.value)} />
            </div>

            <div style={{ textAlign: "right" }}>
              <button className="btn action-button"
                style={{ marginRight: "8px", backgroundColor: this.isStandaloneReminderReadOnly() ? "#282a6596" : undefined }}
                disabled={this.isStandaloneReminderReadOnly()}
                title={this.isStandaloneReminderReadOnly() ? "Read-only treatment defined by admin" : ""}
                onClick={() => this.autoTranslateReminder(this.state.selectedReminderLanguage)}>
                Auto-translate
              </button>
              <button className="btn action-button"
                style={{ backgroundColor: this.isStandaloneReminderReadOnly() ? "#282a6596" : undefined }}
                disabled={this.isStandaloneReminderReadOnly()}
                title={this.isStandaloneReminderReadOnly() ? "Read-only treatment defined by admin" : ""}
                onClick={this.saveReminderTranslation}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Procedure);



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Procedure.js